(function(){
'use strict';
var MC_API='https://script.google.com/macros/s/AKfycbx4cDDEvk8YNl8_ObUtTyXL44ASWsO24yYbN4RUmPpSekq3eGhyuZGRQ4ieg8_DBoUq/exec';
var MC_TOKEN='mc_cc6f126b6aaf46bfa553068c22727813';

/* ───── state ───── */
var cats=[], gastos=[], filtered=[];
var editId=null;
var _listAnimated=false;   /* anima a lista só na 1ª renderização */
var _animFutureIn=false;   /* item 10: anima a entrada dos gastos futuros (cima→baixo) ao ligar/alterar */
var range='30d', customStart=null, customEnd=null;
var showFuturos=false;          /* configuração geral (aba `config` → incluir_futuros) */
var horizMeses=1;               /* config geral (gastos_horizonte_meses): projeta até o fim do N-ésimo mês à frente */
var GKEY='mc_gastos_v1', CKEY='mc_gastos_cats_v1', CFGKEY='mc_gastos_cfg_v1';
var SAVE_SVG='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>';

/* ───── util ───── */
function BRL(v){return'R$ '+Number(v||0).toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:2});}
/* datas vêm como 'YYYY-MM-DD' (ou ISO): new Date() as lê em UTC e no fuso de
   Brasília elas retrocediam um dia na exibição. Lê o texto direto. */
function fmtDate(s){if(!s)return'-';var o=ymd(s);return o?pad2(o.d)+'/'+pad2(o.m)+'/'+o.y:'-';}
/* data curta p/ a lista: "3 Mar", "13 Abr" */
var MESES_ABBR=['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'];
function fmtDayMon(s){var o=ymd(s);return o?(o.d+' '+MESES_ABBR[o.m-1]):'-';}
function toLocalDate(s){var o=ymd(s);return o?new Date(o.y,o.m-1,o.d):null;}
function parseVal(s){return parseFloat(String(s).replace(',','.'))||0;}
/* valor exibido por ocorrência: parcelado guarda o TOTAL, então mostramos
   total ÷ nº de parcelas em cada linha (real e projetada). */
function occValor(g){var v=parseVal(g.valor);if(String(g.tipo)==='parcelado'){var p=Number(g.parcelas)||0;if(p>0)return v/p;}return v;}
/* ───── ícone por categoria (SVG, herda a cor do texto = amarelo) ───── */
function stripAcc(s){return String(s||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim();}
var CAT_ICONS={
  'trafego':'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 11l18-5v12L3 14z"/><path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"/></svg>',
  'frete':'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>',
  'plataforma':'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>',
  /* item 5: insumos e embalagem trocam de ícone — embalagem fica com a caixa/pacote; insumos com camadas (estoque de material) */
  'embalagem':'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>',
  'insumos':'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>',
  'equipamento':'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>',
  'produtos':'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z"/></svg>',
  'produto':'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z"/></svg>',
  'aporte':'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="19" x2="12" y2="5"/><polyline points="5 12 12 5 19 12"/></svg>',
  'venda':'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>'
};
var CAT_ICON_DEFAULT='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>';
function catIcon(name){return CAT_ICONS[stripAcc(name)]||CAT_ICON_DEFAULT;}
/* classe de cor por categoria: gera "mcg-cat-<slug>" a partir do nome (sem acento, sem espaços).
   As cores ficam no CSS de gastos.html (.mcg-cat-<slug>), fáceis de editar. */
function catSlug(name){var s=stripAcc(name).replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');return s||'sem';}
function catTagClass(name){return 'mcg-cat-'+catSlug(name);}
/* impacto no caixa por categoria (usado na página Financeiro). Guardado em config.cat_impacto (JSON). */
var catImpMap={};
function defImpactoG(nome){var k=stripAcc(nome);if(k==='frete')return'pedido';if(k==='insumos'||k==='insumo')return'pedido';return'direto';}
function getCatImp(c){if(!c)return'direto';var m=catImpMap[String(c.id)];return m||defImpactoG(c.nome);}
function setCatImp(id,val){catImpMap[String(id)]=val;persistCfg({cat_impacto:JSON.stringify(catImpMap)});}
var IMP_OPTS=[['direto','Sai do caixa'],['pedido','Via pedidos'],['info','Informativo']];
function uid(){return Date.now().toString(36)+Math.random().toString(36).slice(2);}
function autoGrow(el){if(!el)return;el.style.height='auto';el.style.height=(el.scrollHeight)+'px';}

/* ── feedback de salvamento + trava ao fechar ── */
var pendingSaves=0;
function beginSave(){pendingSaves++;updateSavingUI();}
function endSave(){pendingSaves=Math.max(0,pendingSaves-1);updateSavingUI();}
/* Sem indicador visual de "salvando" — pendingSaves só alimenta o aviso do navegador (beforeunload). */
function updateSavingUI(){}
function toast(){}
function tryClose(fn){fn();}
function closeModalForce(){document.getElementById('mcg-modal-overlay').style.display='none';}
function closeCatModalForce(){document.getElementById('mcg-cat-overlay').style.display='none';}

/* ── dropdowns customizados (preto/amarelo, sem highlight azul do nativo) ── */
function buildAllCS(){document.querySelectorAll('#mc-root select').forEach(buildCS);}
function buildCS(sel){
  if(sel.dataset.csDone)return;
  sel.dataset.csDone='1';
  var wrap=document.createElement('div');wrap.className='mcg-cs';
  sel.parentNode.insertBefore(wrap,sel);wrap.appendChild(sel);
  sel.classList.add('mcg-cs-native');
  var trig=document.createElement('button');trig.type='button';trig.className='mcg-cs-trigger';
  var list=document.createElement('div');list.className='mcg-cs-list';
  wrap.appendChild(trig);wrap.appendChild(list);
  trig.addEventListener('click',function(e){e.stopPropagation();var wasOpen=wrap.classList.contains('open');closeAllCS();if(typeof closeAllDCal==='function')closeAllDCal();if(!wasOpen)wrap.classList.add('open');});
  refreshCS(sel);
}
function refreshCS(sel){
  if(!sel||!sel.dataset.csDone)return;
  var wrap=sel.parentNode; if(!wrap||!wrap.classList.contains('mcg-cs'))return;
  var trig=wrap.querySelector('.mcg-cs-trigger'), list=wrap.querySelector('.mcg-cs-list');
  var cur=sel.options[sel.selectedIndex];
  trig.textContent=cur?cur.textContent:'';
  list.innerHTML='';
  Array.prototype.forEach.call(sel.options,function(o){
    /* item 24: placeholder "Sem categoria" não aparece na lista (só como texto do gatilho) */
    if(o.className&&o.className.indexOf('mcg-opt-ph')>=0)return;
    /* item 25: cabeçalho de subdivisão (option disabled) — não clicável */
    if(o.disabled||(o.className&&o.className.indexOf('mcg-opt-head')>=0)){var hd=document.createElement('div');hd.className='mcg-cs-head';hd.textContent=o.textContent;list.appendChild(hd);return;}
    var it=document.createElement('div');
    it.className='mcg-cs-item'+(o.selected?' sel':'')+(o.className?(' '+o.className):'');
    it.textContent=o.textContent;
    it.addEventListener('click',function(e){
      e.stopPropagation();
      wrap.classList.remove('open');
      if(o.value==='__newcat__'){openCatModal();return;} // não altera a categoria já escolhida
      sel.value=o.value;
      sel.dispatchEvent(new Event('change',{bubbles:true}));
      refreshCS(sel);
    });
    list.appendChild(it);
  });
}
function refreshCSById(id){refreshCS(document.getElementById(id));}
function closeAllCS(){document.querySelectorAll('#mc-root .mcg-cs.open').forEach(function(w){w.classList.remove('open');});}

function rangeWindow(){
  var now=new Date(), s,e=new Date(now);
  e.setHours(23,59,59,999);
  if(range==='7d'){s=new Date(now);s.setDate(s.getDate()-6);s.setHours(0,0,0,0);}
  else if(range==='30d'){s=new Date(now);s.setDate(s.getDate()-29);s.setHours(0,0,0,0);}
  else if(range==='mes'){s=new Date(now.getFullYear(),now.getMonth(),1);}
  else if(range==='3m'){s=new Date(now);s.setMonth(s.getMonth()-3);s.setHours(0,0,0,0);}
  else if(range==='ano'){s=new Date(now.getFullYear(),0,1);}
  else if(range==='custom'&&customStart&&customEnd){s=new Date(customStart);e=new Date(customEnd);e.setHours(23,59,59,999);}
  else{s=new Date(now);s.setDate(s.getDate()-29);s.setHours(0,0,0,0);}
  return{s:s,e:e};
}

function inRange(dateStr){
  var d=toLocalDate(dateStr);
  if(!d)return false;
  var w=rangeWindow();
  return d>=w.s&&d<=w.e;
}
function isFuture(dateStr){
  var d=toLocalDate(dateStr);
  if(!d)return false;
  var now=new Date();now.setHours(23,59,59,999);
  return d>now;
}
function daysUntil(dateStr){
  var d=toLocalDate(dateStr);
  if(!d)return 0;
  var now=new Date();now.setHours(0,0,0,0);
  return Math.round((d-now)/86400000);
}

/* ───── cache local (write-through: toda mutação grava na hora) ───── */
function writeGastosCache(){try{localStorage.setItem(GKEY,JSON.stringify({ts:Date.now(),rows:gastos}));}catch(e){}}
function writeCatsCache(){try{localStorage.setItem(CKEY,JSON.stringify({ts:Date.now(),rows:cats}));}catch(e){}}
function readCfgCache(){try{return JSON.parse(localStorage.getItem(CFGKEY))||{};}catch(e){return{};}}
function writeCfgCache(c){try{localStorage.setItem(CFGKEY,JSON.stringify(c||{}));}catch(e){}}

/* ───── projeção de recorrentes/parcelados ─────
   As datas são tratadas como texto YYYY-MM-DD (sem Date) para não sofrer
   deslocamento de fuso e para comparar direto por ordem lexicográfica. */
function pad2(n){return(n<10?'0':'')+n;}
function ymd(s){
  if(!s)return null;
  var m=String(s).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if(m)return{y:+m[1],m:+m[2],d:+m[3]};
  var dt=new Date(s); if(isNaN(dt))return null;
  return{y:dt.getFullYear(),m:dt.getMonth()+1,d:dt.getDate()};
}
function ymdOf(dt){return{y:dt.getFullYear(),m:dt.getMonth()+1,d:dt.getDate()};}
function ymdStr(o){return o.y+'-'+pad2(o.m)+'-'+pad2(o.d);}
function dim(y,m){return new Date(y,m,0).getDate();}   /* m 1-based */
function addPeriod(o,rec,n){
  if(rec==='diario'||rec==='semanal'||rec==='quinzenal'){
    var step=rec==='semanal'?7:(rec==='quinzenal'?15:1);
    var dt=new Date(o.y,o.m-1,o.d); dt.setDate(dt.getDate()+step*n);
    return ymdOf(dt);
  }
  var t=(o.m-1)+((rec==='anual'?12:1)*n);
  var y=o.y+Math.floor(t/12), m=((t%12)+12)%12+1;
  return {y:y,m:m,d:Math.min(o.d,dim(y,m))};       /* 31/01 + 1 mês → 28/02 */
}
function serieKey(g,o,rec){
  var base=String(g.serie_id||g.parent_id||g.id||'');
  var per=(rec==='diario'||rec==='semanal'||rec==='quinzenal')?ymdStr(o):(o.y+'-'+pad2(o.m));
  return base+'|'+per;
}
var MAX_PROJ=3000;
/* Gera as ocorrências de cada recorrente/parcelado até `until` (YYYY-MM-DD),
   respeitando data_fim e o total de parcelas, sem duplicar linhas reais. */
function expandRecorrentes(rows,until){
  var out=rows.slice(), seen={}, made=0;
  rows.forEach(function(g){
    var o=ymd(g.data||g.data_inicio||g.created_at);
    if(o)seen[serieKey(g,o,g.recorrencia||'mensal')]=1;
  });
  rows.forEach(function(g){
    if(made>=MAX_PROJ)return;
    if(g.virtual)return;                       /* nunca projeta em cima de projeção */
    var tipo=String(g.tipo||'');
    if(tipo!=='recorrente'&&tipo!=='parcelado')return;
    if(String(g.ativo)==='0')return;
    var base=ymd(g.data||g.data_inicio||g.created_at); if(!base)return;
    var rec=(tipo==='parcelado')?'mensal':(String(g.recorrencia||'mensal'));
    var fim=g.data_fim?ymd(g.data_fim):null;
    var fimStr=fim?ymdStr(fim):null;
    var max=600;
    if(tipo==='parcelado'){
      var tot=Number(g.parcelas)||0, atual=Number(g.parcela_atual)||1;
      max=tot?Math.max(0,tot-atual):0;
    }
    for(var n=1;n<=max;n++){
      var o=addPeriod(base,rec,n), s=ymdStr(o);
      if(s>until)break;
      if(fimStr&&s>fimStr)break;
      var k=serieKey(g,o,rec);
      if(seen[k])continue;
      seen[k]=1;
      var v={}; Object.keys(g).forEach(function(kk){v[kk]=g[kk];});
      v.id=String(g.id)+'::'+n;
      v.parent_id=String(g.serie_id||g.id);
      v.data=s;
      v.virtual=true;
      if(tipo==='parcelado')v.parcela_atual=(Number(g.parcela_atual)||1)+n;
      out.push(v);
      if(++made>=MAX_PROJ)break;
    }
  });
  return out;
}

/* ───── JSONP — convenção padrão do Midnight-Sync (key/resource/callback) ───── */
function mcCall(route,params,cb){
  if(typeof window!=='undefined'&&window.MCG_CFG_STUB){return window.MCG_CFG_STUB(route,params,cb);}
  /* re-tenta em falha transitória (net/timeout): garante que todo dispositivo
     alcance os mesmos dados do servidor em vez de ficar preso em cache velho. */
  var attempt=0, MAXTRY=3;
  function go(){
    var cbName='_mc_cb_'+Date.now()+'_'+Math.random().toString(36).slice(2);
    var url=MC_API+'?key='+encodeURIComponent(MC_TOKEN)+'&callback='+cbName+'&resource='+encodeURIComponent(route);
    if(params)Object.keys(params).forEach(function(k){url+='&'+k+'='+encodeURIComponent(params[k]);});
    var s=document.createElement('script'),done=false;
    window[cbName]=function(d){done=true;try{delete window[cbName];}catch(e){}if(s.parentNode)s.parentNode.removeChild(s);cb(null,d);};
    s.src=url;s.onerror=function(){if(done)return;done=true;try{delete window[cbName];}catch(e){}if(s.parentNode)s.parentNode.removeChild(s);retry(new Error('net'));};
    document.head.appendChild(s);
    setTimeout(function(){if(!done&&window[cbName]){done=true;try{delete window[cbName];}catch(e){}if(s.parentNode)s.parentNode.removeChild(s);retry(new Error('timeout'));}},20000);
  }
  function retry(err){attempt++;if(attempt<MAXTRY){setTimeout(go,700*attempt);}else{cb(err);}}
  go();
}

/* ───── load categories ───── */
function loadCats(cb){
  // stale-while-revalidate: categorias do cache na hora, revalida ao fundo
  var stale=null;
  try{ var s=localStorage.getItem(CKEY); if(s) stale=JSON.parse(s); }catch(e){}
  if(stale&&Array.isArray(stale.rows)){ cats=stale.rows; renderCatSelects(); if(cb){ cb(); cb=null; } }
  mcCall('categorias_list',{},function(err,d){
    var arr=d&&(d.data||d.rows);
    if(!err&&Array.isArray(arr)){
      cats=arr;
      writeCatsCache();
    } else if(!stale){ cats=[]; }
    renderCatSelects();
    if(cb)cb();
  });
}

function loadGastos(){
  // stale-while-revalidate: mostra o cache na hora e revalida ao fundo
  var stale=null;
  try{ var s=localStorage.getItem(GKEY); if(s) stale=JSON.parse(s); }catch(e){}
  if(stale&&Array.isArray(stale.rows)){ gastos=stale.rows; applyFilters(); }
  else document.getElementById('mcg-list').innerHTML='<p class="mc-empty">Carregando...</p>';
  mcCall('gastos_list',{},function(err,d){
    var arr=d&&(d.data||d.rows);
    if(!err&&Array.isArray(arr)){
      gastos=arr;
      writeGastosCache();
    } else if(!stale){ gastos=[]; }
    applyFilters();
  });
}

/* ───── filters & render ───── */
function applyFilters(){
  var q=(document.getElementById('mcg-search').value||'').toLowerCase();
  var catF=document.getElementById('mcg-filter-cat').value;
  var tipoF=document.getElementById('mcg-filter-tipo').value;

  /* horizonte da projeção: até hoje sempre (para contabilizar as ocorrências já
     vencidas de um recorrente antigo) e, com "incluir futuros" ligado, até o
     FIM do N-ésimo mês à frente — mês fechado, não uma data solta N meses adiante. */
  var w=rangeWindow();
  var until=ymdStr(ymdOf(new Date()));
  var faturaMode=viewMode==='fatura';
  if(faturaMode){
    /* item 1: a Fatura mostra SEMPRE toda a fatura ativa, inclusive os futuros da janela */
    until=ymdStr(ymdOf(activeFaturaWin().end));
  }else if(showFuturos){
    var a=ymdOf(w.e), t=(a.m-1)+horizMeses;
    var hy=a.y+Math.floor(t/12), hm=((t%12)+12)%12+1;
    var h=ymdStr({y:hy,m:hm,d:dim(hy,hm)});
    if(h>until)until=h;
  }
  var base=expandRecorrentes(gastos,until);

  filtered=base.filter(function(g){
    var dt=g.data||g.created_at;
    if(faturaMode){
      /* item 1: só crédito e só o que cai na janela da fatura atual (inclusive futuro) */
      if(!isCredito(g))return false;
      if(!inFaturaWindow(dt))return false;
      if(q&&!(g.descricao||'').toLowerCase().includes(q))return false;
      if(catF&&String(g.categoria_id)!==String(catF))return false;
      if(tipoF&&g.tipo!==tipoF)return false;
      return true;
    }
    var dateOk=inRange(dt)||(showFuturos&&isFuture(dt)&&String(dt).slice(0,10)<=until);
    if(!dateOk)return false;
    if(q&&!(g.descricao||'').toLowerCase().includes(q))return false;
    if(catF&&String(g.categoria_id)!==String(catF))return false;
    if(tipoF&&g.tipo!==tipoF)return false;
    return true;
  });

  /* item 3: nos futuros, os RECORRENTES aparecem no máximo 1x (a ocorrência mais próxima),
     mesmo ampliando o horizonte; os PARCELADOS continuam 1 por parcela. */
  if(showFuturos&&!faturaMode){
    var earliest={};
    filtered.forEach(function(g){
      var dt=g.data||g.created_at;
      if(!isFuture(dt)||g.tipo==='parcelado')return;
      var sid=String(g.serie_id||g.parent_id||g.id);
      var ds=String(dt).slice(0,10);
      if(!earliest[sid]||ds<earliest[sid].ds)earliest[sid]={ds:ds,ref:g};
    });
    filtered=filtered.filter(function(g){
      var dt=g.data||g.created_at;
      if(!isFuture(dt)||g.tipo==='parcelado')return true;
      var sid=String(g.serie_id||g.parent_id||g.id);
      return earliest[sid]&&earliest[sid].ref===g;
    });
  }

  renderList();
  renderKpis();
  renderByCat();
  updateClearBtn();
  if(MC_PAGE==='fatura'){refreshFaturaSelect();applyFaturaReadonly();}
}
/* item 13: o botão limpar (ícone de lixeira) só aparece com filtro de categoria ou tipo ativo */
function updateClearBtn(){
  var b=document.getElementById('mcg-filter-clear'); if(!b)return;
  var cat=document.getElementById('mcg-filter-cat'), tipo=document.getElementById('mcg-filter-tipo');
  var on=(cat&&cat.value)||(tipo&&tipo.value);
  b.style.display=on?'':'none';
}

/* categoria especial APORTE — movimentações positivas (entradas), só tipo pontual.
   Sintética no cliente (não persiste no backend); o gasto guarda categoria_id='__aporte__'. */
var APORTE_ID='__aporte__';
var APORTE_CAT={id:APORTE_ID,nome:'Aporte',cor:'#48f91e',positivo:true};
function isAporte(g){return String(g&&g.categoria_id)===APORTE_ID;}
function ensureAporte(){if(!cats.some(function(c){return String(c.id)===APORTE_ID;}))cats.unshift(APORTE_CAT);}
/* categoria sintética PRODUTOS — usada pelo custo dinâmico de produto (antes ia em Insumos) */
var PRODUTOS_ID='__produtos__';
var PRODUTOS_CAT={id:PRODUTOS_ID,nome:'Produto',cor:'#22d3ee'};
/* categoria sintética FRETE — usada quando NÃO existe uma categoria chamada "Frete" no cadastro.
   Sem isso o frete dinâmico sumia do KPI/breakdown da Fatura (mas aparecia na lista), deixando o
   valor MENOR que o Financeiro. */
var FRETE_ID='__frete__';
var FRETE_CAT={id:FRETE_ID,nome:'Frete',cor:'#2fae57'};
function freteCatIdOr(){var id=freteCatId();return id!=null?id:FRETE_ID;}
function getCat(id){if(String(id)===APORTE_ID)return APORTE_CAT;if(String(id)===PRODUTOS_ID)return PRODUTOS_CAT;if(String(id)===FRETE_ID)return FRETE_CAT;return cats.find(function(c){return String(c.id)===String(id);})||null;}

/* ───── método de pagamento + fatura (crédito) ───── */
var metodoMap={}, adiantados=[], viewMode='gastos';
/* item 3: datas manuais para pagamentos dinâmicos (frete/produto). Chave estável por lote:
   'frete-open' / 'prod-open' para o item em aberto, e 'frete-'+paidAt / 'prod-'+paidAt para lotes
   pagos. Valor = 'YYYY-MM-DD'. Sobrepõe a data usada na exibição e na atribuição de fatura. */
/* data manual guardada EM chaves que o backend já salva (não depende de config_save novo):
   - lote pago (frete/produto): no próprio lote, b.payDate → persiste em frete_batches/prod_batches
   - item em aberto: em _openOvr[kind] → persiste dentro de frete_open/prod_open (campo .ovr) */
var _openOvr={frete:null,prod:null};
function payOvrGet(kind,state,batch){if(state==='open')return _openOvr[kind]||null;return (batch&&batch.payDate)||null;}
function setPayDateOvr(kind,state,batch,ymd){
  if(state==='open'){_openOvr[kind]=ymd||null;persistOpens(true);}
  else if(batch){if(ymd)batch.payDate=ymd;else{try{delete batch.payDate;}catch(e){batch.payDate=null;}}pPersist();}
}
/* item 4: o método (crédito/pix) é da SÉRIE inteira. Ocorrências virtuais (parceladas/mensais
   futuras) têm id "real::n", então resolvem pelo parent_id/serie_id — assim todas as instâncias
   ficam com o mesmo método e não sai uma crédito e outra pix. */
function getMetodo(g){
  if(!g)return 'pix';
  var m=metodoMap[String(g.id)]; if(m)return m;
  var pid=g.parent_id||g.serie_id;
  if(pid){var pm=metodoMap[String(pid)]; if(pm)return pm;}
  return g.metodo||'pix';
}
function isCredito(g){return getMetodo(g)==='credito';}
/* item 4: cada fatura fecha no dia 2 — cobre as compras do dia 2 de um mês ATÉ o dia 1 do mês
   seguinte (sem sobreposição). Compra no dia 1 → fatura anterior; no dia 2 → próxima fatura.
   O dia 5 é só a data de vencimento/pagamento, não define quem entra na fatura. */
function faturaWindow(ref){ref=ref||new Date();var y=ref.getFullYear(),m=ref.getMonth();var start=new Date(y,m,2,0,0,0);if(ref<start){start=new Date(y,m-1,2,0,0,0);}var end=new Date(start.getFullYear(),start.getMonth()+1,1,23,59,59);return{start:start,end:end};}
/* rótulo do mês de referência da fatura cuja janela começa em `start` (ex.: AGO/2026) */
function faturaRefKey(start){return start.getFullYear()+'-'+pad2(start.getMonth()+1);}
/* fatura em foco: null = fatura atual; caso contrário uma Date de referência dentro da janela
   histórica escolhida no dropdown (item 5 — faturas passadas, somente leitura). */
var faturaViewRef=null;
function activeFaturaWin(){return faturaWindow(faturaViewRef||new Date());}
function isFaturaHist(){return !!faturaViewRef;}
function inFaturaWindow(dateStr,win){var d=toLocalDate(dateStr)||(dateStr?new Date(dateStr):null);if(!d)return false;var w=win||activeFaturaWin();return d>=w.start&&d<=w.end;}
/* página atual: 'gastos' ou 'fatura' (data-page no #mc-root). A Fatura vira página própria (item 5). */
var MC_PAGE='gastos';
var PMESES_UP=['JAN','FEV','MAR','ABR','MAI','JUN','JUL','AGO','SET','OUT','NOV','DEZ'];
/* meses de fatura que têm algo registrado (crédito/frete), pro dropdown de faturas passadas */
function faturaMonthsWithData(){
  var set={}, curKey=faturaRefKey(faturaWindow(new Date()).start); set[curKey]=1;
  /* expande recorrentes/parcelados até a fatura atual, pra um mês que só tem ocorrência
     recorrente (sem gasto avulso) também aparecer no dropdown de faturas passadas. */
  var until=ymdStr(ymdOf(faturaWindow(new Date()).end));
  try{expandRecorrentes(gastos,until).forEach(function(g){if(isAporte(g)||!isCredito(g))return;var d=toLocalDate(g.data||g.created_at);if(!d)return;set[faturaRefKey(faturaWindow(d).start)]=1;});}catch(e){
    (gastos||[]).forEach(function(g){if(isAporte(g)||!isCredito(g))return;var d=toLocalDate(g.data||g.created_at);if(!d)return;set[faturaRefKey(faturaWindow(d).start)]=1;});
  }
  (freteBatches||[]).forEach(function(b){var d=toLocalDate(payOvrGet('frete','paid',b)||b.to);if(d)set[faturaRefKey(faturaWindow(d).start)]=1;});
  try{pOpenOrders(freteBatches).forEach(function(o){var d=pOrderDate(o);if(d)set[faturaRefKey(faturaWindow(d).start)]=1;});}catch(e){}
  return {cur:curKey,keys:Object.keys(set)};
}
function faturaSelLabel(k){var y=+k.slice(0,4),m=+k.slice(5,7);return PMESES_UP[m-1]+'/'+y;}
function refreshFaturaSelect(){
  var sel=document.getElementById('mcg-filter-fatura'); if(!sel)return;
  var mm=faturaMonthsWithData(), curKey=mm.cur;
  var past=mm.keys.filter(function(k){return k<curKey;}).sort().reverse();
  var sig=curKey+'|'+past.join(',');
  if(sel._faturaSig!==sig){
    sel._faturaSig=sig;
    var html='<option value="">Fatura atual</option>';
    past.forEach(function(k){html+='<option value="'+k+'">'+faturaSelLabel(k)+'</option>';});
    sel.innerHTML=html;
    try{refreshCSById('mcg-filter-fatura');}catch(e){}
  }
  var want=faturaViewRef?faturaRefKey(faturaWindow(faturaViewRef).start):'';
  if(want===curKey)want='';
  if(sel.value!==want){sel.value=want;try{refreshCSById('mcg-filter-fatura');}catch(e){}}
}
/* aplica o estado somente-leitura (fatura passada): esconde Adiantar e +Novo */
function applyFaturaReadonly(){
  var ro=isFaturaHist();
  var root=document.getElementById('mc-root'); if(root)root.classList.toggle('is-fatura-hist',ro);
  var ad=document.getElementById('mcg-adiantar'); if(ad)ad.style.display=ro?'none':'';
  var nv=document.getElementById('mcg-btn-new'); if(nv&&MC_PAGE==='fatura')nv.style.display=ro?'none':'';
}
function _paidIdsSet(){var s={};adiantados.forEach(function(r){(r.ids||[]).forEach(function(id){s[String(id)]=1;});});return s;}
function isPagoAdiantado(g){return !!_paidIdsSet()[String(g&&(g.id||(g.parent_id)))]||!!_paidIdsSet()[String(g&&g.parent_id)];}
/* item 4: crédito com data <= 14 ago 2026 já é considerado PAGO (não entra na fatura pendente
   nem mexe no caixa — controle histórico). */
var FATURA_CUTOFF=new Date(2026,7,14);
function beforeFaturaCutoff(dateStr){var d=toLocalDate(dateStr)||(dateStr?new Date(dateStr):null);return !!(d&&startOfDayLocal(d)<=FATURA_CUTOFF);}
function startOfDayLocal(d){return new Date(d.getFullYear(),d.getMonth(),d.getDate());}
function isCreditoPago(g){return isPagoAdiantado(g)||beforeFaturaCutoff(g&&(g.data||g.created_at));}
/* soma das ocorrências em crédito da fatura ativa (janela atual), não pagas / pagas */
function faturaSums(){
  var pend=0,pago=0,ids={};
  var paid=_paidIdsSet();
  var win=activeFaturaWin();
  var base=expandRecorrentes(gastos,ymdStr(ymdOf(win.end)));
  base.forEach(function(g){
    if(isAporte(g))return; if(!isCredito(g))return;
    var dt=g.data||g.created_at; if(!inFaturaWindow(dt,win))return;
    var v=occValor(g);
    var gid=String(g.id||g.parent_id||'');
    var pagoJa=paid[gid]||paid[String(g.parent_id||'')]||beforeFaturaCutoff(dt);   /* item 4 */
    if(pagoJa){pago+=v;}else{pend+=v;ids[gid]=1;}
  });
  /* item 8/2: o frete dinâmico (crédito) entra na fatura DA JANELA — cada pedido aberto é
     atribuído pela sua própria data, então o frete do mês passado não vaza pra fatura atual. */
  freteFaturaEntries(win).forEach(function(f){if(beforeFaturaCutoff(f.data)){pago+=f.v;}else{pend+=f.v;}});
  return {pendente:pend,pago:pago,ids:Object.keys(ids)};
}
/* item 2/3: entradas de frete (crédito) que caem DENTRO da janela `win`, atribuídas por data.
   - lotes pagos: data = override manual (item 3) ou b.to;
   - item aberto: sem override, cada pedido conta na fatura da SUA data (corrige o vazamento);
     com override manual, o item aberto inteiro usa a data escolhida. */
function freteFaturaEntries(win){
  win=win||activeFaturaWin();
  var out=[];   /* conta o frete mesmo sem existir categoria "Frete" no cadastro */
  freteBatches.forEach(function(b){
    var d=payOvrGet('frete','paid',b)||b.to;
    var dt=toLocalDate(d)||(d?new Date(d):null); if(!dt)return;
    if(dt>=win.start&&dt<=win.end)out.push({v:parseVal(b.valor),data:d});
  });
  var fo=pOpenOrders(freteBatches);
  var ovr=payOvrGet('frete','open',null);
  if(ovr){
    var od=toLocalDate(ovr)||new Date(ovr);
    if(od>=win.start&&od<=win.end){var fv=fo.reduce(function(s,o){return s+pFrete(o);},0);if(fv)out.push({v:pRound2(fv),data:ovr});}
  }else{
    fo.forEach(function(o){var d=pOrderDate(o);if(!d)return;if(d>=win.start&&d<=win.end)out.push({v:pRound2(pFrete(o)),data:pIso(d)});});
  }
  return out;
}

function gastoRowHtml(g,delay,doAnim){
  var cat=getCat(g.categoria_id);
  var catName=cat?cat.nome:'Sem categoria';
  var tipoClass=g.tipo==='recorrente'?'rec':g.tipo==='parcelado'?'parc':'';
  var parc=(g.parcela_atual||1)+'/'+(g.parcelas||'?');
  var tipoLabel;
  if(g.tipo==='recorrente'){var r=String(g.recorrencia||'mensal');tipoLabel=r.charAt(0).toUpperCase()+r.slice(1);}
  else if(g.tipo==='parcelado')tipoLabel='Parcela '+parc;   /* item 8: "Parcela 1/3" */
  else tipoLabel='Pontual';
  /* item 3: mostra em quantas vezes está dividido ("• 3x"); item 9: bullet menor */
  var parcTag=g.tipo==='parcelado'?'<span class="mcg-val-parc"><span class="mcg-parc-dot">•</span> '+escH(g.parcelas||'?')+'x</span>':'';
  var apor=isAporte(g);
  /* aporte mantém "+"; gasto normal sem sinal */
  var valInner=apor?('<span class="mcg-val-pos">+'+BRL(occValor(g))+'</span>'):(BRL(occValor(g))+parcTag);
  var dt=g.data||g.created_at;
  var fut=isFuture(dt);
  var dias=daysUntil(dt);
  var daysBadge=fut?('<span class="mcg-row-days">faltam '+dias+(dias===1?' dia':' dias')+'</span>'):'';
  var prevBadge=(g.virtual&&!fut)?'<span class="mcg-row-prev">previsto</span>':'';
  var rid=g.virtual?(g.parent_id||g.id):g.id;
  /* item 1: na Fatura, sem faixa "futuro" (só "faltam X dias"); item 4: os itens já PAGOS ficam escurecidos */
  var faturaMode=viewMode==='fatura';
  var futCls=(fut&&!faturaMode)?' is-future':'';
  var paidCls=(faturaMode&&isCredito(g)&&isCreditoPago(g))?' is-paid-credit':'';
  return '<div class="mcg-row'+(doAnim?' mcg-row-in':'')+(g.virtual?' is-virtual':'')+futCls+paidCls+'" data-id="'+escH(rid)+'"'+(doAnim?' style="animation-delay:'+delay+'ms"':'')+'>'
    +'<span class="mcg-row-catcell"><span class="mcg-row-cat-tag '+catTagClass(cat?cat.nome:'')+'" title="'+escH(cat?cat.nome:'Sem categoria')+'">'+catIcon(cat?cat.nome:'')+'<span class="mcg-cat-txt">'+escH(catName)+'</span></span></span>'
    +'<span class="mcg-row-val">'+valInner+'</span>'
    +'<span class="mcg-row-desc" title="'+escH(g.notas||'')+'">'+escH(g.descricao||'-')+(g.notas?'<span class="mcg-row-notas">'+escH(g.notas)+'</span>':'')+'</span>'
    +'<span class="mcg-row-prazo">'+daysBadge+prevBadge+'</span>'
    +'<span class="mcg-row-data">'+fmtDayMon(dt)+'</span>'
    +'<span class="mcg-row-metodo '+(isCredito(g)?'is-credito':'is-pix')+'">'+(isCredito(g)?'Crédito':'Pix')+'</span>'
    +'<span class="mcg-row-tipo '+tipoClass+'">'+escH(tipoLabel)+'</span>'
    +(g.virtual?'<span class="mcg-row-del-sp"></span>':'<button class="mcg-row-del" data-del="'+escH(g.id)+'" title="Excluir">✕</button>')
    +'</div>';
}
function renderList(){
  var el=document.getElementById('mcg-list');
  var doAnim=!_listAnimated; _listAnimated=true;
  var animFut=_animFutureIn; _animFutureIn=false;   /* item 10: entrada suave dos futuros */
  /* pagáveis e gastos entram na MESMA lista, ordenados por data (pagáveis = hoje),
     então ficam abaixo dos gastos futuros, como os demais. */
  var items=renderPayableItems();
  filtered.forEach(function(g){items.push({date:new Date(g.data||g.created_at||0),g:g});});
  items.sort(function(a,b){return b.date-a.date;});
  if(!items.length){el.innerHTML='<p class="mc-empty" style="padding:20px">Nenhum gasto no período.</p>';return;}
  var futSeq=0;
  el.innerHTML=items.map(function(x,i){
    if(x.html!=null)return x.html;
    var rowFut=isFuture(x.g.data||x.g.created_at);
    var da=doAnim||(animFut&&rowFut);
    /* futuros entram de cima pra baixo, escalonados */
    var delay=doAnim?Math.min(i,16)*28:(animFut&&rowFut?(futSeq++)*45:0);
    return gastoRowHtml(x.g,delay,da);
  }).join('');

  el.querySelectorAll('.mcg-row').forEach(function(row){
    if(row.classList.contains('mcg-pay-row'))return;   /* pagáveis têm handler próprio (bindPayable) */
    if(row.classList.contains('mcg-order-row'))return; /* pedidos (Venda) não editáveis */
    row.addEventListener('click',function(e){
      if(e.target.dataset.del)return;
      openEdit(row.dataset.id);
    });
  });
  el.querySelectorAll('[data-del]').forEach(function(btn){
    btn.addEventListener('click',function(e){e.stopPropagation();confirmDel(btn.dataset.del);});
  });
  bindPayable(el);
}

function escH(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}

/* embaralha as letras/dígitos até assentar no valor novo (roll da esquerda p/ direita).
   Caracteres não alfanuméricos (R$ . , % espaço) passam direto. */
function scrambleTo(el,finalText,frames){
  if(!el)return;
  finalText=String(finalText==null?'':finalText);
  if(el.textContent===finalText)return;
  frames=frames||16;
  if(el._scrCancel)el._scrCancel();
  var DIG='0123456789',GLY='ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  var frame=0,running=true;
  el._scrCancel=function(){running=false;};
  function tick(){
    if(!running)return;
    var prog=frame/frames,out='';
    for(var i=0;i<finalText.length;i++){
      var fc=finalText[i];
      if(!/[A-Za-z0-9]/.test(fc)){out+=fc;continue;}
      if(prog>=(i+1)/finalText.length){out+=fc;}
      else{var set=/[0-9]/.test(fc)?DIG:GLY;out+=set[Math.floor(Math.random()*set.length)];}
    }
    el.textContent=out;
    if(frame++>=frames){el.textContent=finalText;running=false;el._scrCancel=null;return;}
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
}

function renderKpis(){
  var gastosTot=0,aportes=0;
  filtered.forEach(function(g){
    var v=occValor(g);
    if(isAporte(g)){aportes+=v;return;}   /* aporte = entrada, não é gasto */
    gastosTot+=v;
  });
  if(viewMode!=='fatura'){
    prodPayableEntries().forEach(function(p){if(!inRange(p.data))return;gastosTot+=p.v;});   /* produto (pix) só na aba Gastos */
    fretePayableEntries().forEach(function(p){if(!inRange(p.data))return;gastosTot+=p.v;});   /* item 5: frete dinâmico entra em Gastos */
  }
  /* item 7: custos mensais = soma dos recorrentes mensais (por mês); parcelamentos =
     soma das parcelas que caem no mês atual dos gastos parcelados ativos. */
  var now=new Date();
  var custosMensais=0, parcelamentos=0;
  _recList=[]; _parcList=[];
  var seenRec={};   /* item 4: 1 recorrente por série (sem duplicar "Shopify") */
  gastos.forEach(function(g){
    if(isAporte(g))return;
    if(g.tipo==='recorrente'&&String(g.recorrencia||'mensal')==='mensal'){
      var sid=stripAcc(g.descricao||'')||String(g.serie_id||g.parent_id||g.id);   /* 1 por item/nome no mês */
      if(seenRec[sid])return; seenRec[sid]=1;
      var rv=parseVal(g.valor); custosMensais+=rv;
      _recList.push({nome:g.descricao||'-',valor:rv});
      return;
    }
    if(g.tipo==='parcelado'){
      var start=toLocalDate(g.data_inicio||g.data); if(!start)return;
      var pn=Number(g.parcelas)||0; if(pn<=0)return;
      var diff=(now.getFullYear()-start.getFullYear())*12+(now.getMonth()-start.getMonth());
      if(diff>=0&&diff<pn){
        var vp=parseVal(g.valor)/pn; parcelamentos+=vp;
        var dia=Math.min(start.getDate(),new Date(now.getFullYear(),now.getMonth()+1,0).getDate());
        var pagto=pad2(dia)+'/'+pad2(now.getMonth()+1);
        var num=(Number(g.parcela_atual)||1)+diff; if(num>pn)num=pn;
        _parcList.push({nome:g.descricao||'-',valor:vp,data:pagto,parcela:num+'/'+pn});
      }
    }
  });
  /* itens 2/3: na aba Fatura, "Gastos"→"Fatura" (pendente) e "Aportes"→"Adiantado" (pago) */
  function kpiLbl(id,txt){var v=document.getElementById(id);if(!v)return;var l=v.parentNode.querySelector('.mcg-kpi-lbl');if(l)l.textContent=txt;}
  if(viewMode==='fatura'){
    var fs=faturaSums();
    if(isFaturaHist()){
      /* fatura passada: "Fatura total" = pendente + já adiantado/pago daquele mês */
      kpiLbl('mcg-k-gastos','Fatura total'); scrambleTo(document.getElementById('mcg-k-gastos'),BRL(fs.pendente+fs.pago));
    }else{
      kpiLbl('mcg-k-gastos','Fatura'); scrambleTo(document.getElementById('mcg-k-gastos'),BRL(fs.pendente));
    }
    kpiLbl('mcg-k-aportes','Adiantado'); scrambleTo(document.getElementById('mcg-k-aportes'),BRL(fs.pago));
  }else{
    kpiLbl('mcg-k-gastos','Gastos'); scrambleTo(document.getElementById('mcg-k-gastos'),BRL(gastosTot));
    kpiLbl('mcg-k-aportes','Aportes'); scrambleTo(document.getElementById('mcg-k-aportes'),BRL(aportes));
  }
  scrambleTo(document.getElementById('mcg-k-mensais'),BRL(custosMensais));
  scrambleTo(document.getElementById('mcg-k-parcelas'),BRL(parcelamentos));
}
var _recList=[], _parcList=[];
/* ───── abas Gastos / Fatura + adiantar pagamento ───── */
function setView(v){
  if(viewMode===v)return;
  viewMode=v;
  var root=document.getElementById('mc-root'); if(root)root.classList.toggle('is-fatura',v==='fatura');
  var fw=document.getElementById('mcg-fut-wrap'); if(fw)fw.style.display=(v==='fatura')?'none':'';   /* item 7: sem "gastos futuros" na Fatura */
  Array.prototype.forEach.call(document.querySelectorAll('.mcg-vtab'),function(b){b.classList.toggle('is-active',b.getAttribute('data-view')===v);});
  var menu=document.getElementById('mcg-fatura-menu'); if(menu)menu.classList.remove('open');
  applyFilters();
}
var _pendingAdiantar=null;
function bindViews(){
  Array.prototype.forEach.call(document.querySelectorAll('.mcg-vtab'),function(b){
    b.addEventListener('click',function(e){if(e.target.closest('#mcg-fatura-caret'))return;setView(b.getAttribute('data-view'));});
  });
  var caret=document.getElementById('mcg-fatura-caret');
  if(caret)caret.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();var m=document.getElementById('mcg-fatura-menu');if(m)m.classList.toggle('open');});
  document.addEventListener('click',function(e){var m=document.getElementById('mcg-fatura-menu');if(m&&!e.target.closest('.mcg-viewtabs'))m.classList.remove('open');});
  var adBtn=document.getElementById('mcg-adiantar');
  if(adBtn)adBtn.addEventListener('click',function(){
    var m=document.getElementById('mcg-fatura-menu'); if(m)m.classList.remove('open');
    if(isFaturaHist()){alert('Fatura passada é somente leitura.');return;}
    var fs=faturaSums();
    if(!fs.pendente){alert('Não há valor em aberto na fatura.');return;}
    document.getElementById('mcg-adiantar-msg').innerHTML='Marcar como PAGO toda a fatura ativa (<b>'+BRL(fs.pendente)+'</b>, '+fs.ids.length+' item(ns))? Os itens ficam adiantados e passam a sair do caixa.';
    _pendingAdiantar=fs;
    document.getElementById('mcg-adiantar-overlay').style.display='flex';
  });
  var adCancel=document.getElementById('mcg-adiantar-cancel'); if(adCancel)adCancel.addEventListener('click',function(){document.getElementById('mcg-adiantar-overlay').style.display='none';});
  var adOk=document.getElementById('mcg-adiantar-ok'); if(adOk)adOk.addEventListener('click',function(){
    var fs=_pendingAdiantar||faturaSums();
    if(fs&&fs.ids&&fs.ids.length){adiantados.push({ts:new Date().toISOString(),valor:fs.pendente,ids:fs.ids});persistCfg({fatura_adiantado:JSON.stringify(adiantados)});}
    _pendingAdiantar=null;
    document.getElementById('mcg-adiantar-overlay').style.display='none';
    applyFilters();
  });
}
function kpiTip(){var t=document.getElementById('mcg-kpitip');if(!t){t=document.createElement('div');t.id='mcg-kpitip';document.body.appendChild(t);}return t;}
function kpiTipHtml(kind){
  if(kind==='rec'){
    if(!_recList.length)return '<div class="mcg-kt-empty">Nenhum gasto recorrente</div>';
    return '<div class="mcg-kt-h">Gastos recorrentes</div>'+_recList.map(function(r){return '<div class="mcg-kt-r"><span>'+escH(r.nome)+'</span><span class="mcg-kt-v">'+BRL(r.valor)+'</span></div>';}).join('');
  }
  if(!_parcList.length)return '<div class="mcg-kt-empty">Nenhum parcelamento no mês</div>';
  return '<div class="mcg-kt-h">Parcelas do mês</div>'+_parcList.map(function(r){return '<div class="mcg-kt-r"><span>'+escH(r.nome)+'<span class="mcg-kt-sub">parcela '+escH(r.parcela)+' · '+escH(r.data)+'</span></span><span class="mcg-kt-v">'+BRL(r.valor)+'</span></div>';}).join('');
}
function bindKpiTips(){
  ['rec','parc'].forEach(function(kind){
    var card=document.querySelector('.mcg-kpi[data-kpi="'+(kind==='rec'?'recorrentes':'parcelamentos')+'"]');
    if(!card||card._ktBound)return; card._ktBound=true;
    card.addEventListener('mousemove',function(e){var t=kpiTip();t.style.left=Math.min(e.clientX+14,window.innerWidth-260)+'px';t.style.top=(e.clientY+16)+'px';});
    card.addEventListener('mouseenter',function(){var t=kpiTip();t.innerHTML=kpiTipHtml(kind);t.classList.add('show');});
    card.addEventListener('mouseleave',function(){kpiTip().classList.remove('show');});
  });
}

var _byCatPrev=null,_animByCat=false,_byCatSig='';
function renderByCat(){
  var byCat={};
  var total=0;
  filtered.forEach(function(g){
    if(isAporte(g))return;   /* aportes não entram no breakdown de despesas */
    var v=occValor(g);
    total+=v;
    var cid=String(g.categoria_id||'__sem__');
    byCat[cid]=(byCat[cid]||0)+v;
  });
  if(viewMode!=='fatura')prodPayableEntries().forEach(function(p){if(!inRange(p.data))return;total+=p.v;byCat[p.cid]=(byCat[p.cid]||0)+p.v;});   /* produto só na aba Gastos */
  /* item 5/8/2: frete dinâmico entra em Gastos por categoria nas DUAS abas (é crédito).
     Na Fatura usa a atribuição por janela (freteFaturaEntries) pra não vazar o mês passado. */
  if(viewMode==='fatura'){
    var _fid=freteCatIdOr(); freteFaturaEntries().forEach(function(f){total+=f.v;byCat[_fid]=(byCat[_fid]||0)+f.v;});
  }else{
    fretePayableEntries().forEach(function(p){if(!inRange(p.data))return;total+=p.v;byCat[p.cid]=(byCat[p.cid]||0)+p.v;});
  }
  /* novo: na aba Gastos, TODAS as categorias aparecem sempre — mesmo zeradas (R$ 0,00) */
  if(viewMode!=='fatura')cats.forEach(function(c){if(String(c.id)===APORTE_ID)return;var cid=String(c.id);if(byCat[cid]==null)byCat[cid]=0;});
  var sorted=Object.keys(byCat).sort(function(a,b){return byCat[b]-byCat[a];});
  var el=document.getElementById('mcg-by-cat');
  if(!sorted.length){el.innerHTML='<p class="mc-empty" style="padding:12px 0">Sem dados.</p>';renderPie([],0);_byCatPrev=null;_animByCat=false;_byCatSig='';return;}
  /* item 22: se os dados não mudaram, não mexe (evita "piscar") */
  var sig=sorted.map(function(cid){return cid+':'+byCat[cid];}).join('|');
  if(sig===_byCatSig&&el.children.length&&!el.querySelector('.mc-empty')){renderPieFromByCat(sorted,byCat,total);return;}
  _byCatSig=sig; _animByCat=false;
  /* item 8: reconciliação — atualiza as barras/valores existentes NO LUGAR (transição a partir
     da posição atual, sem reiniciar do 0) e só embaralha os valores que mudaram. */
  var hadRows=!!el.querySelector('.mcg-cat-row');
  var existing={};
  Array.prototype.forEach.call(el.querySelectorAll('.mcg-cat-row'),function(r){existing[r.getAttribute('data-cid')]=r;});
  var ordered=[];
  sorted.forEach(function(cid){
    var cat=cid==='__sem__'?null:getCat(cid);
    var v=byCat[cid], pct=total?Math.round(v/total*100):0;
    var nm=cat?cat.nome:'Sem categoria', cor=cat?cat.cor:'#444';
    var bt=BRL(v);
    var row=existing[cid];
    if(row){
      var bar=row.querySelector('.mcg-cat-bar');
      if(bar){bar.setAttribute('data-w',pct);bar.style.width=pct+'%';bar.style.background='var(--acc)';}   /* barra sempre amarela */
      var sq=row.querySelector('.mcg-cat-sq'); if(sq)sq.style.background=cor;
      var val=row.querySelector('.mcg-cat-val');
      if(val&&val.getAttribute('data-val')!==bt){val.setAttribute('data-val',bt);scrambleTo(val,bt);}   /* só embaralha se mudou */
      delete existing[cid];
    }else{
      row=document.createElement('div');
      row.className='mcg-cat-row'+(hadRows?' mcg-cat-in':'');
      row.setAttribute('data-cid',cid);
      /* quadrado (sem arredondamento) na cor da categoria + barra sempre amarela */
      row.innerHTML='<span class="mcg-cat-nm" title="'+escH(nm)+'"><span class="mcg-cat-sq" style="background:'+cor+'"></span>'+escH(nm)+'</span>'
        +'<div class="mcg-cat-bar-wrap"><div class="mcg-cat-bar" style="width:0;background:var(--acc)" data-w="'+pct+'"></div></div>'
        +'<span class="mcg-cat-val" data-val="'+bt+'"></span>';
      (function(d){requestAnimationFrame(function(){var b=d.querySelector('.mcg-cat-bar');if(b)b.style.width=(b.getAttribute('data-w')||0)+'%';var s=d.querySelector('.mcg-cat-val');if(s)scrambleTo(s,s.getAttribute('data-val'));});})(row);
    }
    ordered.push(row);
  });
  /* remove categorias que sumiram */
  Object.keys(existing).forEach(function(cid){var r=existing[cid];if(r&&r.parentNode)r.parentNode.removeChild(r);});
  /* reordena in-place (insertBefore mantém os nós conectados → não reinicia as transições) */
  ordered.forEach(function(row,i){if(el.children[i]!==row)el.insertBefore(row,el.children[i]||null);});
  _byCatPrev={}; sorted.forEach(function(cid){_byCatPrev[cid]=1;});
  renderPieFromByCat(sorted,byCat,total);
}
function renderPieFromByCat(sorted,byCat,total){
  renderPie(sorted.map(function(cid){
    var cat=cid==='__sem__'?null:getCat(cid);
    return { cid:cid, v:byCat[cid],
      nm: cat?((cat.icone?cat.icone+' ':'')+cat.nome):'Sem categoria',
      cor: (cat&&cat.cor)?cat.cor:'#444' };
  }),total);
}

/* ───── gráfico pizza por categoria (animação de entrada + hover via delegação) ───── */
var _pieAnim=null,_pieSig='',_pieItems=[],_pieTotal=0,_pieBound=false;
function pieSetCenter(v,l,color,scram){var cv=document.getElementById('mcg-pie-c-val'),cl=document.getElementById('mcg-pie-c-lbl');if(cv){cv.style.color=color||'';if(scram)scrambleTo(cv,v);else cv.textContent=v;}if(cl)cl.textContent=l;}
function pieShowTip(it){var tip=document.getElementById('mcg-pie-tip'),nm=document.getElementById('mcg-pie-tip-nm'),vl=document.getElementById('mcg-pie-tip-val');if(tip)tip.hidden=false;if(nm){nm.textContent=it.nm;nm.style.color=it.cor;}if(vl)vl.textContent=BRL(it.v)+' · '+Math.round(it.v/_pieTotal*100)+'%';}
function pieClearHover(svg){svg.classList.remove('has-hot');Array.prototype.forEach.call(svg.querySelectorAll('.mcg-slice.is-hot'),function(x){x.classList.remove('is-hot');});pieSetCenter(BRL(_pieTotal),'Total');var tip=document.getElementById('mcg-pie-tip');if(tip)tip.hidden=true;}
function pieBind(svg){
  if(_pieBound)return; _pieBound=true;
  svg.addEventListener('mousemove',function(e){
    if(_pieAnim)return; /* ignora hover durante a animação de entrada */
    var p=(e.target&&e.target.closest)?e.target.closest('.mcg-slice'):null;
    /* a fatia destacada só é solta ao SAIR do gráfico (mouseleave) ou ao passar por OUTRA fatia;
       mover pro interior (miolo) mantém o destaque atual. */
    if(!p)return;
    if(p.classList.contains('is-hot'))return; /* já destacada */
    var it=_pieItems[parseInt(p.getAttribute('data-i'),10)];
    if(!it)return;
    svg.classList.add('has-hot');
    Array.prototype.forEach.call(svg.querySelectorAll('.mcg-slice.is-hot'),function(x){x.classList.remove('is-hot');});
    p.classList.add('is-hot');
    pieSetCenter(BRL(it.v),Math.round(it.v/_pieTotal*100)+'%',it.cor);
    pieShowTip(it);
  });
  svg.addEventListener('mouseleave',function(){pieClearHover(svg);});
}
function renderPie(items,total){
  var wrap=document.getElementById('mcg-pie-wrap'),svg=document.getElementById('mcg-pie');
  if(!wrap||!svg)return;
  if(!items.length||!total){svg.innerHTML='';wrap.style.display='none';_pieSig='';_pieItems=[];_pieTotal=0;return;}
  wrap.style.display='';
  _pieItems=items;_pieTotal=total;
  pieBind(svg);
  pieSetCenter(BRL(total),'Total',null,true);
  var sig=items.map(function(it){return it.cid+':'+Math.round(it.v);}).join('|');
  var animate=sig!==_pieSig;
  _pieSig=sig;
  if(_pieAnim){cancelAnimationFrame(_pieAnim);_pieAnim=null;}
  var CX=110,CY=110,R=92,TAU=Math.PI*2;
  function arcPath(a0,a1){
    if(a1-a0>=TAU-0.0001){
      return 'M '+CX+' '+(CY-R)+' A '+R+' '+R+' 0 1 1 '+(CX-0.01)+' '+(CY-R)+' Z';
    }
    var x0=CX+R*Math.sin(a0),y0=CY-R*Math.cos(a0);
    var x1=CX+R*Math.sin(a1),y1=CY-R*Math.cos(a1);
    var large=(a1-a0)>Math.PI?1:0;
    return 'M '+CX+' '+CY+' L '+x0.toFixed(2)+' '+y0.toFixed(2)+' A '+R+' '+R+' 0 '+large+' 1 '+x1.toFixed(2)+' '+y1.toFixed(2)+' Z';
  }
  function build(prog){
    var html='',acc=0,lim=prog*TAU;
    items.forEach(function(it,i){
      var a0=acc;
      acc+=it.v/total*TAU;
      var a1=acc;
      if(a0>=lim)return;
      var mid=(a0+a1)/2;
      html+='<path d="'+arcPath(a0,Math.min(a1,lim))+'" fill="'+it.cor+'" data-i="'+i+'" class="mcg-slice"'
        +' style="--px:'+(Math.sin(mid)*9).toFixed(2)+'px;--py:'+(-Math.cos(mid)*9).toFixed(2)+'px"/>';
    });
    html+='<circle cx="110" cy="110" r="63" fill="#0d0d0d"/>';
    svg.innerHTML=html;
  }
  if(animate){
    var t0=performance.now(),DUR=650;
    var tick=function(now){
      var p=Math.min(1,(now-t0)/DUR);
      var e=1-Math.pow(1-p,3);
      build(e);
      if(p<1){_pieAnim=requestAnimationFrame(tick);}
      else{_pieAnim=null;}
    };
    _pieAnim=requestAnimationFrame(tick);
  } else {
    build(1);
  }
}

/* ───── category selects ───── */
function renderCatSelects(){
  ensureAporte();   /* Aporte sempre no início das categorias */
  /* item 24: "Sem categoria" é só placeholder (não listado); "+ Nova categoria" fica fixo no fim.
     item 25: subdivisão "Gastos" entre o Aporte e as demais categorias. */
  function catOpt(c){return '<option value="'+c.id+'">'+(c.icone?c.icone+' ':'')+escH(c.nome)+'</option>';}
  var aporte=cats.filter(function(c){return String(c.id)===APORTE_ID;});
  var rest=cats.filter(function(c){return String(c.id)!==APORTE_ID;});
  var opts='<option value="" class="mcg-opt-ph">Sem categoria</option>'
    +aporte.map(catOpt).join('')
    +'<option disabled class="mcg-opt-head">Gastos</option>'
    +rest.map(catOpt).join('');
  document.getElementById('mcg-f-cat').innerHTML=opts+'<option value="__newcat__" class="mcg-opt-new">+ Nova categoria</option>';
  var f=document.getElementById('mcg-filter-cat');
  f.innerHTML='<option value="">Todas categorias</option>'+cats.map(function(c){
    return '<option value="'+c.id+'">'+(c.icone?c.icone+' ':'')+escH(c.nome)+'</option>';
  }).join('');
  refreshCSById('mcg-f-cat');refreshCSById('mcg-filter-cat');
}

/* ───── modal gasto ───── */
function openModal(id){
  editId=id||null;
  var g=id?gastos.find(function(x){return String(x.id)===String(id);}):null;
  document.getElementById('mcg-modal-title').textContent=g?'Editar movimentação':'Nova movimentação';
  document.getElementById('mcg-modal-del').style.display=g?'':'none';
  document.getElementById('mcg-f-desc').value=g?g.descricao:'';
  document.getElementById('mcg-f-valor').value=g?g.valor:'';
  document.getElementById('mcg-f-cat').value=g?String(g.categoria_id||''):'';
  var tipo=g?g.tipo:'pontual';
  document.getElementById('mcg-f-tipo').value=tipo;
  document.getElementById('mcg-f-data').value=g&&g.data?g.data.slice(0,10):new Date().toISOString().slice(0,10);
  document.getElementById('mcg-f-inicio').value=g&&g.data_inicio?g.data_inicio.slice(0,10):'';
  document.getElementById('mcg-f-fim').value=g&&g.data_fim?g.data_fim.slice(0,10):'';
  document.getElementById('mcg-f-recorr').value=g?g.recorrencia||'mensal':'mensal';
  document.getElementById('mcg-f-parc-data').value=g&&g.data_inicio?g.data_inicio.slice(0,10):new Date().toISOString().slice(0,10);
  document.getElementById('mcg-f-parcelas').value=g?g.parcelas||12:12;
  document.getElementById('mcg-f-parc-atual').value=g?g.parcela_atual||1:1;
  document.getElementById('mcg-f-notas').value=g?g.notas||'':'';
  document.getElementById('mcg-f-metodo').value=g?getMetodo(g):(MC_PAGE==='fatura'?'credito':'pix');   /* item 1: Fatura sempre crédito */
  autoGrow(document.getElementById('mcg-f-notas'));
  updateTipoBlocks(tipo);
  refreshCSById('mcg-f-cat');refreshCSById('mcg-f-tipo');refreshCSById('mcg-f-recorr');refreshCSById('mcg-f-metodo');
  onCatChange();   /* aporte trava tipo em pontual e esconde o campo Tipo */
  refreshAllDCal();   /* atualiza os gatilhos dos calendários de data */
  document.getElementById('mcg-modal-overlay').style.display='flex';
  document.getElementById('mcg-f-desc').focus();
}

function openEdit(id){openModal(id);}
function closeModal(){document.getElementById('mcg-modal-overlay').style.display='none';}

/* Aporte só tem tipo pontual: força pontual e esconde o campo Tipo */
function onCatChange(){
  var v=document.getElementById('mcg-f-cat').value;
  var field=document.getElementById('mcg-f-tipo-field');
  if(v===APORTE_ID){
    var t=document.getElementById('mcg-f-tipo'); if(t.value!=='pontual'){t.value='pontual';refreshCSById('mcg-f-tipo');}
    updateTipoBlocks('pontual');
    if(field)field.style.display='none';
  }else{ if(field)field.style.display=''; }
}

function updateTipoBlocks(tipo){
  document.getElementById('mcg-f-pontual-block').style.display=(tipo==='pontual'||tipo==='parcelado')?'':(!tipo||tipo==='pontual'?'':'none');
  document.getElementById('mcg-f-pontual-block').style.display=(tipo==='pontual')?'flex':'none';
  document.getElementById('mcg-f-rec-block').style.display=(tipo==='recorrente')?'block':'none';
  document.getElementById('mcg-f-parc-block').style.display=(tipo==='parcelado')?'block':'none';
}

function saveGasto(){
  var desc=document.getElementById('mcg-f-desc').value.trim();
  var valor=parseVal(document.getElementById('mcg-f-valor').value);
  if(!desc){alert('Informe a descrição.');return;}
  if(!valor){alert('Informe o valor.');return;}
  var tipo=document.getElementById('mcg-f-tipo').value;
  var params={
    id: editId||uid(),
    descricao: desc,
    valor: valor,
    categoria_id: document.getElementById('mcg-f-cat').value,
    tipo: tipo,
    notas: document.getElementById('mcg-f-notas').value,
    ativo: '1'
  };
  if(tipo==='pontual'){
    params.data=document.getElementById('mcg-f-data').value;
  } else if(tipo==='recorrente'){
    params.recorrencia=document.getElementById('mcg-f-recorr').value;
    params.data_inicio=document.getElementById('mcg-f-inicio').value;
    params.data_fim=document.getElementById('mcg-f-fim').value;
    params.data=params.data_inicio;
  } else if(tipo==='parcelado'){
    params.data=document.getElementById('mcg-f-parc-data').value;
    params.data_inicio=params.data;
    params.parcelas=document.getElementById('mcg-f-parcelas').value;
    params.parcela_atual=document.getElementById('mcg-f-parc-atual').value;
  }
  /* método (pix/crédito) fica na config (mapa por id), sem depender de coluna no backend.
     item 1: na página Fatura, todo gasto novo é forçado a crédito. */
  var metodo=(MC_PAGE==='fatura')?'credito':(document.getElementById('mcg-f-metodo').value||'pix');
  if(metodo==='credito')metodoMap[String(params.id)]='credito'; else delete metodoMap[String(params.id)];
  persistCfg({gasto_metodo:JSON.stringify(metodoMap)});
  // atualização otimista: reflete na hora e salva ao fundo
  var localRow={}; Object.keys(params).forEach(function(k){localRow[k]=params[k];});
  localRow.metodo=metodo;
  localRow.valor=parseVal(params.valor);
  var exIdx=gastos.findIndex(function(x){return String(x.id)===String(params.id);});
  if(exIdx>=0){localRow.created_at=gastos[exIdx].created_at||new Date().toISOString();gastos[exIdx]=localRow;}
  else{localRow.created_at=new Date().toISOString();gastos.unshift(localRow);}
  writeGastosCache();
  applyFilters();
  closeModalForce();
  beginSave();
  mcCall('gastos_save',params,function(err,d){
    endSave();
    if(err||(d&&d.error)){alert('Erro ao salvar: '+((d&&d.error)||(err&&err.message)||'sem resposta do servidor'));}
    loadGastos();
  });
}

function confirmDel(id){
  if(!confirm('Excluir este gasto?'))return;
  gastos=gastos.filter(function(x){return String(x.id)!==String(id);});
  writeGastosCache();
  applyFilters();
  closeModalForce();
  beginSave();
  mcCall('gastos_delete',{id:id},function(err,d){
    endSave();
    if(err||(d&&d.error)){alert('Erro ao excluir: '+((d&&d.error)||(err&&err.message)||'sem resposta do servidor'));}
    loadGastos();
  });
}

/* ───── modal categorias ───── */
function openCatModal(){
  renderCatList();
  document.getElementById('mcg-cat-overlay').style.display='flex';
}
function closeCatModal(){document.getElementById('mcg-cat-overlay').style.display='none';}

function renderCatList(){
  var el=document.getElementById('mcg-cat-list');
  if(!cats.length){el.innerHTML='<p class="mc-empty">Nenhuma categoria ainda.</p>';return;}
  el.innerHTML=cats.map(function(c){
    var imp=getCatImp(c);
    var opts=IMP_OPTS.map(function(o){return '<option value="'+o[0]+'"'+(o[0]===imp?' selected':'')+'>'+o[1]+'</option>';}).join('');
    return '<div class="mcg-cat-item" data-cid="'+c.id+'">'
      +'<input type="color" class="mcg-cat-swatch" value="'+(c.cor||'#fff200')+'" title="Trocar cor">'
      +'<input type="text" class="mcg-cat-name-in" value="'+escH(c.nome||'')+'" title="Editar nome">'
      +'<select class="mcg-cat-imp" title="Impacto no caixa (Financeiro)">'+opts+'</select>'
      +'<button class="mcg-cat-save" title="Salvar alterações">'+SAVE_SVG+'</button>'
      +'<button class="mcg-cat-item-del" data-del="'+c.id+'">✕</button>'
      +'</div>';
  }).join('');
  el.querySelectorAll('.mcg-cat-item').forEach(function(item){
    var id=item.dataset.cid;
    var sw=item.querySelector('.mcg-cat-swatch');
    var nm=item.querySelector('.mcg-cat-name-in');
    var sv=item.querySelector('.mcg-cat-save');
    var imp=item.querySelector('.mcg-cat-imp');
    function markDirty(){item.classList.add('dirty');}
    sw.addEventListener('input',markDirty);
    nm.addEventListener('input',markDirty);
    imp.addEventListener('change',function(){setCatImp(id,imp.value);});
    sv.addEventListener('click',function(){
      var nome=nm.value.trim();
      if(!nome){alert('O nome não pode ficar vazio.');return;}
      saveCatEdit(id,{nome:nome,cor:sw.value},item);
    });
    item.querySelector('[data-del]').addEventListener('click',function(){delCat(id);});
  });
}
function saveCatEdit(id,fields,item){
  var c=cats.find(function(x){return String(x.id)===String(id);});
  if(!c)return;
  if(fields.nome!=null)c.nome=fields.nome;
  if(fields.cor!=null)c.cor=fields.cor;
  // NÃO re-renderiza a lista de categorias (preservando edições não salvas das outras linhas);
  // só marca esta linha como salva e atualiza os dropdowns + a lista de gastos.
  if(item)item.classList.remove('dirty');
  writeCatsCache();
  renderCatSelects();applyFilters();
  var payload={id:id,nome:c.nome||'',cor:c.cor||'#fff200',icone:c.icone||'',ordem:c.ordem||1};
  beginSave();
  mcCall('categorias_save',payload,function(err,d){
    endSave();
    if(err||(d&&d.error)){alert('Erro ao editar categoria: '+((d&&d.error)||(err&&err.message)||'sem resposta do servidor'));loadCats(function(){renderCatList();renderCatSelects();applyFilters();});}
  });
}

function addCat(){
  var nm=document.getElementById('mcg-cat-nm').value.trim();
  if(!nm){alert('Informe o nome.');return;}
  var cor=document.getElementById('mcg-cat-cor').value;
  var newCat={id:uid(),nome:nm,cor:cor,icone:'',ordem:cats.length+1};
  cats.push(newCat);
  document.getElementById('mcg-cat-nm').value='';
  writeCatsCache();
  renderCatList();renderCatSelects();
  beginSave();
  mcCall('categorias_save',newCat,function(err,d){
    endSave();
    if(err||(d&&d.error)){alert('Erro ao salvar categoria: '+((d&&d.error)||(err&&err.message)||'sem resposta do servidor'));}
    loadCats(function(){renderCatList();renderCatSelects();});
  });
}

function delCat(id){
  if(!confirm('Excluir categoria?'))return;
  cats=cats.filter(function(x){return String(x.id)!==String(id);});
  writeCatsCache();
  renderCatList();renderCatSelects();applyFilters();
  beginSave();
  mcCall('categorias_delete',{id:id},function(err,d){
    endSave();
    if(err||(d&&d.error)){alert('Erro ao excluir categoria: '+((d&&d.error)||(err&&err.message)||'sem resposta do servidor'));loadCats(function(){renderCatList();renderCatSelects();applyFilters();});}
  });
}

/* ───── range picker (calendário estilo Aquisição) ───── */
var GMONTHS=["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"];
var RANGE_LABELS={'7d':'7 dias','30d':'30 dias','mes':'Mês','3m':'3 meses','ano':'Ano'};
function calIso(d){return d.getFullYear()+'-'+pad2(d.getMonth()+1)+'-'+pad2(d.getDate());}
function calBR(d){return pad2(d.getDate())+'/'+pad2(d.getMonth()+1);}
function calSame(a,b){return a&&b&&a.getFullYear()===b.getFullYear()&&a.getMonth()===b.getMonth()&&a.getDate()===b.getDate();}
function setupRange(){
  var wrap=document.getElementById('mcg-rangepicker');
  var toggle=document.getElementById('mcg-range-toggle');
  var lbl=document.getElementById('mcg-range-label');
  var container=document.getElementById('mcg-cal');
  if(!wrap||!toggle||!container)return;
  var st={view:null,start:null,end:null,open:false,grid:null,title:null,rng:null};
  var today=new Date();today.setHours(0,0,0,0);
  st.view=new Date(today.getFullYear(),today.getMonth(),1);
  container.style.display='none';
  var presets=[['7d','7 dias'],['30d','30 dias'],['mes','Mês'],['3m','3 meses'],['ano','Ano']];
  container.innerHTML=
    '<div class="mcg-cal-presets">'
      +presets.map(function(o){return '<button type="button" data-range="'+o[0]+'">'+o[1]+'</button>';}).join('')
    +'</div>'
    +'<div class="mcg-cal-main">'
      +'<div class="mcg-cal-head">'
        +'<button type="button" class="mcg-cal-prev">‹</button>'
        +'<span class="mcg-cal-title"></span>'
        +'<button type="button" class="mcg-cal-next">›</button>'
      +'</div>'
      +'<div class="mcg-cal-dow"><span>D</span><span>S</span><span>T</span><span>Q</span><span>Q</span><span>S</span><span>S</span></div>'
      +'<div class="mcg-cal-grid"></div>'
      +'<div class="mcg-cal-foot">'
        +'<span class="mcg-cal-rng"></span>'
        +'<button type="button" class="mcg-cal-apply">Aplicar</button>'
      +'</div>'
    +'</div>';
  st.grid=container.querySelector('.mcg-cal-grid');
  st.title=container.querySelector('.mcg-cal-title');
  st.rng=container.querySelector('.mcg-cal-rng');
  function render(){
    var v=st.view;st.title.textContent=GMONTHS[v.getMonth()]+' '+v.getFullYear();
    var first=new Date(v.getFullYear(),v.getMonth(),1),gs=new Date(first.getTime()-first.getDay()*864e5),h='';
    for(var i=0;i<42;i++){
      var d=new Date(gs.getFullYear(),gs.getMonth(),gs.getDate()+i);
      var cls='mcg-cal-day';
      if(d.getMonth()!==v.getMonth())cls+=' out';
      var isS=calSame(d,st.start),isE=calSame(d,st.end);
      if(st.start&&st.end&&d>=st.start&&d<=st.end&&!isS&&!isE)cls+=' inrange';
      if(isS||isE)cls+=' edge';
      if(calSame(d,today)&&!isS&&!isE)cls+=' today';
      h+='<button type="button" class="'+cls+'" data-date="'+calIso(d)+'">'+d.getDate()+'</button>';
    }
    st.grid.innerHTML=h;
    if(st.start){var e=st.end||st.start;st.rng.textContent=calBR(st.start)+((st.end&&!calSame(st.start,st.end))?(' – '+calBR(e)):'');}
    else st.rng.textContent='Selecione um período';
    Array.prototype.forEach.call(container.querySelectorAll('button[data-range]'),function(x){x.classList.toggle('is-active',x.getAttribute('data-range')===range);});
  }
  function syncFromRange(){
    var t=new Date();t.setHours(0,0,0,0);
    if(range==='custom'&&customStart&&customEnd){st.start=new Date(customStart);st.start.setHours(0,0,0,0);st.end=new Date(customEnd);st.end.setHours(0,0,0,0);}
    else{var w=rangeWindow();st.start=new Date(w.s);st.start.setHours(0,0,0,0);st.end=new Date(w.e);st.end.setHours(0,0,0,0);}
    st.view=new Date((st.end||t).getFullYear(),(st.end||t).getMonth(),1);
  }
  function open(o){st.open=o;container.style.display=o?'flex':'none';wrap.classList.toggle('open',o);if(o){syncFromRange();render();}}
  toggle.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();open(!st.open);});
  container.addEventListener('click',function(e){
    e.stopPropagation();
    var pre=e.target.closest('button[data-range]');
    if(pre){range=pre.getAttribute('data-range');lbl.textContent=RANGE_LABELS[range]||range;open(false);applyFilters();return;}
    if(e.target.closest('.mcg-cal-prev')){st.view=new Date(st.view.getFullYear(),st.view.getMonth()-1,1);render();return;}
    if(e.target.closest('.mcg-cal-next')){st.view=new Date(st.view.getFullYear(),st.view.getMonth()+1,1);render();return;}
    if(e.target.closest('.mcg-cal-apply')){if(!st.start)return;var en=st.end||st.start;range='custom';customStart=new Date(st.start);customEnd=new Date(en);lbl.textContent=calBR(st.start)+' – '+calBR(en);open(false);applyFilters();return;}
    var day=e.target.closest('button[data-date]');
    if(day){var p=day.getAttribute('data-date').split('-');var d=new Date(+p[0],+p[1]-1,+p[2]);if(!st.start||st.end){st.start=d;st.end=null;}else{if(d<st.start){st.end=st.start;st.start=d;}else st.end=d;}render();}
  });
  document.addEventListener('click',function(ev){if(!wrap.contains(ev.target))open(false);});
}

/* ───── item 12: seletor de data com o mesmo calendário do período (single, sem presets/período) ───── */
var CAL_ICO='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>';
function closeAllDCal(){document.querySelectorAll('#mc-root .mcg-dcal.open').forEach(function(w){w.classList.remove('open');});}
function buildDateField(id){
  var input=document.getElementById(id);
  if(!input||input.dataset.dcalDone)return; input.dataset.dcalDone='1';
  input.type='hidden';
  var wrap=document.createElement('div'); wrap.className='mcg-dcal';
  input.parentNode.insertBefore(wrap,input); wrap.appendChild(input);
  var trig=document.createElement('button'); trig.type='button'; trig.className='mcg-dcal-trigger';
  var pop=document.createElement('div'); pop.className='mcg-dcal-pop';
  pop.innerHTML='<div class="mcg-cal-main"><div class="mcg-cal-head"><button type="button" class="mcg-cal-prev">‹</button><span class="mcg-cal-title"></span><button type="button" class="mcg-cal-next">›</button></div>'
    +'<div class="mcg-cal-dow"><span>D</span><span>S</span><span>T</span><span>Q</span><span>Q</span><span>S</span><span>S</span></div>'
    +'<div class="mcg-cal-grid"></div></div>';
  wrap.appendChild(trig); wrap.appendChild(pop);
  var grid=pop.querySelector('.mcg-cal-grid'), title=pop.querySelector('.mcg-cal-title');
  var st={view:null};
  function selDate(){if(!input.value)return null;var p=String(input.value).slice(0,10).split('-');if(p.length<3)return null;var d=new Date(+p[0],+p[1]-1,+p[2]);return isNaN(d)?null:d;}
  function refreshTrig(){var d=selDate();trig.innerHTML='<span class="'+(d?'':'mcg-dcal-ph')+'">'+(d?pad2(d.getDate())+'/'+pad2(d.getMonth()+1)+'/'+d.getFullYear():'Selecionar data')+'</span>'+CAL_ICO;}
  function render(){
    var v=st.view; title.textContent=GMONTHS[v.getMonth()]+' '+v.getFullYear();
    var today=new Date();today.setHours(0,0,0,0);
    var sel=selDate();
    var first=new Date(v.getFullYear(),v.getMonth(),1),gs=new Date(first.getTime()-first.getDay()*864e5),h='';
    for(var i=0;i<42;i++){
      var d=new Date(gs.getFullYear(),gs.getMonth(),gs.getDate()+i);
      var cls='mcg-cal-day';
      if(d.getMonth()!==v.getMonth())cls+=' out';
      if(sel&&calSame(d,sel))cls+=' edge';
      else if(calSame(d,today))cls+=' today';
      h+='<button type="button" class="'+cls+'" data-date="'+calIso(d)+'">'+d.getDate()+'</button>';
    }
    grid.innerHTML=h;
  }
  function open(o){wrap.classList.toggle('open',o);if(o){var s=selDate()||new Date();st.view=new Date(s.getFullYear(),s.getMonth(),1);render();}}
  trig.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();var was=wrap.classList.contains('open');closeAllDCal();closeAllCS();if(!was)open(true);});
  pop.addEventListener('click',function(e){
    e.stopPropagation();
    if(e.target.closest('.mcg-cal-prev')){st.view=new Date(st.view.getFullYear(),st.view.getMonth()-1,1);render();return;}
    if(e.target.closest('.mcg-cal-next')){st.view=new Date(st.view.getFullYear(),st.view.getMonth()+1,1);render();return;}
    var day=e.target.closest('button[data-date]');
    if(day){input.value=day.getAttribute('data-date');input.dispatchEvent(new Event('change',{bubbles:true}));refreshTrig();wrap.classList.remove('open');}
  });
  input._dcalRefresh=refreshTrig;
  refreshTrig();
}
function refreshAllDCal(){['mcg-f-data','mcg-f-inicio','mcg-f-fim','mcg-f-parc-data'].forEach(function(id){var el=document.getElementById(id);if(el&&el._dcalRefresh)el._dcalRefresh();});}

/* ───── configuração geral (aba `config` do Apps Script) ───── */
function syncFutUI(animate){
  var el=document.getElementById('mcg-toggle-fut');
  if(el)el.checked=showFuturos;
  var wrap=document.getElementById('mcg-fut-wrap');
  if(wrap)wrap.classList.toggle('is-on',showFuturos);
  animFutRow(showFuturos,animate);
  var sel=document.getElementById('mcg-fut-meses');
  if(sel&&String(sel.value)!==String(horizMeses)){sel.value=String(horizMeses);refreshCS(sel);}
}
/* item 10: cresce/encolhe o dropdown de meses suavemente (com JS, restaurando overflow
   ao final pra não cortar o próprio dropdown quando aberto). */
/* item 6: layout em 2 colunas — a visibilidade do dropdown é só CSS (.is-on), via opacidade.
   Limpa qualquer estilo inline antigo pra não conflitar. */
function animFutRow(show,animate){
  var row=document.querySelector('.mcg-fut-meses-row'); if(!row)return;
  row.style.maxHeight='';row.style.overflow='';row.style.opacity='';row.style.transition='';
}
function applyCfg(c){
  c=c||{};
  if(c.incluir_futuros!==undefined)showFuturos=(String(c.incluir_futuros)==='1'||c.incluir_futuros===true);
  var h=Number(c.gastos_horizonte_meses);
  if(!isNaN(h)&&h>=0&&h<=120)horizMeses=h;
  if(c.cat_impacto){try{var mp=JSON.parse(c.cat_impacto);if(mp&&typeof mp==='object')catImpMap=mp;}catch(e){}}
  if(c.gasto_metodo!==undefined){try{var mm=JSON.parse(c.gasto_metodo||'{}');if(mm&&typeof mm==='object')metodoMap=mm;}catch(e){}}
  if(c.fatura_adiantado!==undefined){try{var ad=JSON.parse(c.fatura_adiantado||'[]');if(Array.isArray(ad))adiantados=ad;}catch(e){}}
  /* data manual do item em aberto vem de dentro de frete_open/prod_open (.ovr) */
  try{var _fo=JSON.parse(c.frete_open||'null');_openOvr.frete=(_fo&&_fo.ovr)||null;}catch(e){}
  try{var _po=JSON.parse(c.prod_open||'null');_openOvr.prod=(_po&&_po.ovr)||null;}catch(e){}
  pLoadBatches(c);
  syncFutUI();
}
/* grava a config: cache primeiro (UI instantânea), servidor depois */
function persistCfg(patch){
  var c=readCfgCache();
  Object.keys(patch).forEach(function(k){c[k]=String(patch[k]);});
  writeCfgCache(c);
  beginSave();
  mcCall('config_save',patch,function(err,d){
    endSave();
    /* falha no servidor: mantém aplicado pelo cache local, sem aviso (o toast
       ficava aparecendo a cada mudança). */
    if(!err&&d&&d.data)writeCfgCache(d.data);
  });
}
function bootCfg(){
  applyCfg(readCfgCache());                       /* cache primeiro: sem piscada no reload */
  mcCall('config_get',{},function(err,d){         /* revalida ao fundo */
    var c=d&&d.data;
    if(err||!c)return;
    writeCfgCache(c);
    var pf=showFuturos, ph=horizMeses;
    applyCfg(c);
    if(pf!==showFuturos||ph!==horizMeses){_animByCat=true;applyFilters();}
  });
}

/* ═══════════ Custos de pedidos pagáveis: Produtos (insumos) e Frete ═══════════
   Cada novo pedido soma custo de produto (bundle/camiseta/moletom via products_period)
   e frete num item aberto ("a pagar"). Ao marcar "Pago", o item é fechado (vira lote pago,
   com data e valor congelados) e novos pedidos começam um novo item aberto.
   Backfill: na 1ª vez cria 1 lote JÁ PAGO com todo o histórico. */
var MC_API_PED='https://script.google.com/macros/s/AKfycbxVP14V5Z7Adf4xT4WZ3cdlCEtjX5qshZZf3keV7ttLuFudGzvoT7K_iHpIiep9fziu/exec';
var PROD_TYPES=['bundle','camiseta','moletom','moleton'];
var PAY_OKEY='mc_gastos_ped_orders_v1';
var finOrders=[], prodBatches=[], freteBatches=[];
var prodOpen={from:null,to:null,valor:null,count:0}, prodCostCache={}, _payReady=false, _payModal=null;
function pRound2(v){return Math.round((v||0)*100)/100;}
function pIso(d){return d.getFullYear()+'-'+pad2(d.getMonth()+1)+'-'+pad2(d.getDate());}
function pSOD(d){var x=new Date(d);x.setHours(0,0,0,0);return x;}
function pDate(s){if(s==null)return null;var m=String(s).match(/^(\d{4})-(\d{2})-(\d{2})$/);if(m)return new Date(+m[1],+m[2]-1,+m[3]);var dt=new Date(s);return isNaN(dt)?null:dt;}
var PMESES=['jan','fev','mar','abr','mai','jun','jul','ago','set','out','nov','dez'];
function pDayLbl(d){return d.getDate()+' '+PMESES[d.getMonth()];}
function pRangeLbl(from,to){var a=pDate(from),b=pDate(to);if(!a)return'';if(!b||pIso(a)===pIso(b))return pDayLbl(a);return pDayLbl(a)+' - '+pDayLbl(b);}
function pedCall(route,params,cb){
  if(typeof window!=='undefined'&&window.MCG_PED_STUB){return window.MCG_PED_STUB(route,params,cb);}
  var attempt=0, MAXTRY=3;
  function go(){
    var name='_mcgp_'+Date.now()+'_'+Math.floor(Math.random()*1e6);
    var url=MC_API_PED+'?key='+encodeURIComponent(MC_TOKEN)+'&callback='+name+'&resource='+encodeURIComponent(route);
    Object.keys(params||{}).forEach(function(k){url+='&'+k+'='+encodeURIComponent(params[k]);});
    var s=document.createElement('script'),done=false;
    window[name]=function(d){done=true;try{delete window[name];}catch(e){}if(s.parentNode)s.parentNode.removeChild(s);cb(null,d);};
    s.src=url;s.onerror=function(){if(done)return;done=true;try{delete window[name];}catch(e){}if(s.parentNode)s.parentNode.removeChild(s);retry(new Error('net'));};
    document.head.appendChild(s);
    setTimeout(function(){if(!done&&window[name]){done=true;try{delete window[name];}catch(e){}if(s.parentNode)s.parentNode.removeChild(s);retry(new Error('timeout'));}},22000);
  }
  function retry(err){attempt++;if(attempt<MAXTRY){setTimeout(go,700*attempt);}else{cb(err);}}
  go();
}
function pMatchType(t){t=stripAcc(t);for(var i=0;i<PROD_TYPES.length;i++)if(t.indexOf(PROD_TYPES[i])>=0)return true;return false;}
function pOrderPaid(o){var st=stripAcc(o.status);return st!=='nao pago'&&st!=='cancelado';}
/* item 7: usa o custo REAL do frete (Frenet), não o valor absorvido pela loja */
function pFrete(o){var r=parseVal(o.frete_real);return r||parseVal(o.frete_pago||0);}
/* item 2: lê a DATA do pedido pelo texto (YYYY-MM-DD) pra não retroceder um dia no fuso de Brasília */
function pOrderDate(o){var s=String(o.created_at||'');var m=s.match(/(\d{4})-(\d{2})-(\d{2})/);if(m)return new Date(+m[1],+m[2]-1,+m[3]);return pDate(o.created_at);}
function pLoadBatches(c){c=c||{};try{var a=JSON.parse(c.prod_batches||'null');if(Array.isArray(a))prodBatches=a;}catch(e){}try{var b=JSON.parse(c.frete_batches||'null');if(Array.isArray(b))freteBatches=b;}catch(e){}}
function pPersist(){persistCfg({prod_batches:JSON.stringify(prodBatches),frete_batches:JSON.stringify(freteBatches)});}
function pLastTo(batches){var m=null;batches.forEach(function(b){var t=pDate(b.to);if(t&&(!m||t>m))m=t;});return m;}
function pMonthStart(){var n=new Date();return new Date(n.getFullYear(),n.getMonth(),1);}
/* corte por timestamp: o item aberto conta os pedidos criados APÓS o último lote pago
   (o backfill inicial fixa o corte em "agora", então só pedidos novos entram). */
function pCutoffTs(batches){var m=null;batches.forEach(function(b){
  var t;
  /* backfill (lote inicial): a janela dinâmica começa no dia SEGUINTE ao último pedido antigo
     (b.to). Assim, com backfill até dia 13, os pedidos do dia 14 em diante já contam. */
  if(b.initial){var td=pDate(b.to);t=td?new Date(pSOD(td).getTime()+864e5-1):pDate(b.cutoff||b.paidAt);}
  else{t=pDate(b.cutoff||b.paidAt||b.to);}
  if(t&&(!m||t>m))m=t;
});return m;}
function pOpenOrders(batches){var ct=pCutoffTs(batches);var floor=ct||new Date(pMonthStart().getTime()-1);return finOrders.filter(pOrderPaid).filter(function(o){var d=pOrderDate(o);return d&&d>floor;});}
function pFetchProdCost(from,to,cb){var key=from+'~'+to;if(prodCostCache[key]!=null){cb(prodCostCache[key]);return;}pedCall('products_period',{range:from+'~'+to},function(e,d){var rows=(d&&(d.rows||d.data))||[];var v=0;rows.forEach(function(r){if(pMatchType(r.product_type))v+=parseVal(r.custo_total_gerado);});if(!e)prodCostCache[key]=v;cb(v,e);});}
function loadPayables(){
  try{var oc=JSON.parse(localStorage.getItem(PAY_OKEY));if(oc&&oc.rows)finOrders=oc.rows;}catch(e){}
  pLoadBatches(readCfgCache());
  refreshPayables();
  /* busca só do início do mês anterior até hoje (payload pequeno — o range enorme
     dava timeout no JSONP). Cobre o mês atual (backfill) + pedidos novos. */
  var from=new Date(); from=new Date(from.getFullYear(),from.getMonth()-1,1);
  pedCall('orders',{range:pIso(from)+'~'+pIso(new Date())},function(e,d){
    var a=d&&(d.rows||d.data);
    if(e){try{console.warn('[mc-gastos] falha ao carregar pedidos p/ Produtos/Frete:',e&&e.message);}catch(_){}return;}
    if(Array.isArray(a)){finOrders=a;try{localStorage.setItem(PAY_OKEY,JSON.stringify({ts:Date.now(),rows:a}));}catch(_){}refreshPayables();}
  });
}
function refreshPayables(){
  _payReady=true;
  var cfg=readCfgCache();
  var paid=finOrders.filter(pOrderPaid);
  /* backfill (uma única vez, marcado por pay_setup): cria 1 lote JÁ PAGO com o custo de
     bundle/camiseta/moletom e o frete do MÊS ATUAL até hoje — só p/ controle dos pedidos
     antigos (não sai do caixa: initial). Fixa o corte em "agora": daqui pra frente, pedidos
     novos entram no item aberto cumulativo. Roda assim que os pedidos carregam. */
  if(cfg.pay_setup!=='v3'&&finOrders.length){
    /* backfill = pedidos ANTIGOS do mês (do início do mês até ONTEM). Fecha em dia-1 pra
       deixar claro que é só controle e NÃO cria um gasto entrando "até hoje" no Financeiro.
       O corte fica no início de hoje: os pedidos de HOJE em diante entram no item aberto. */
    var ms=pMonthStart();
    var todaySOD=pSOD(new Date());
    var yest=new Date(todaySOD.getTime()-864e5);   /* ontem (dia 14) */
    var monthPaid=paid.filter(function(o){var d=pOrderDate(o);return d&&pSOD(d)>=pSOD(ms)&&pSOD(d)<todaySOD;});
    var cutISO=todaySOD.toISOString(), to=pIso(yest);
    var mds=monthPaid.map(pOrderDate).filter(Boolean).sort(function(a,b){return a-b;});
    var from=mds.length?pIso(mds[0]):pIso(ms);
    var frete=monthPaid.reduce(function(s,o){return s+pFrete(o);},0);
    freteBatches=[{from:from,to:to,valor:pRound2(frete),count:monthPaid.length,paidAt:cutISO,cutoff:cutISO,initial:true}];
    prodBatches=[{from:from,to:to,valor:0,pending:true,count:monthPaid.length,paidAt:cutISO,cutoff:cutISO,initial:true}];
    cfg.pay_setup='v3';writeCfgCache(cfg);
    persistCfg({prod_batches:JSON.stringify(prodBatches),frete_batches:JSON.stringify(freteBatches),pay_setup:'v3'});
    computeOrdersProdCost(monthPaid,function(v){var b=prodBatches[0];if(!b||!b.initial)return;b.valor=pRound2(v);b.pending=false;pPersist();payFullRender();});
  }
  /* item ABERTO de produtos = pedidos criados após o corte (novos) até hoje, a pagar.
     Ao marcar Pago, fecha e sai do caixa; novos pedidos abrem outro item. */
  var oo=pOpenOrders(prodBatches);
  if(oo.length){
    var ds2=oo.map(pOrderDate).filter(Boolean).sort(function(a,b){return a-b;});
    /* item 2: intervalo = do 1º ao ÚLTIMO pedido incluído (não "até hoje") */
    prodOpen.from=pIso(ds2[0]);prodOpen.to=pIso(ds2[ds2.length-1]);prodOpen.count=oo.length;prodOpen.valor=null;
    /* item 3: total = soma exata dos custos por pedido (também pré-carrega os detalhes) */
    computeOrdersProdCost(oo,function(v){prodOpen.valor=v;persistOpens();payFullRender();});
  }else{prodOpen.from=null;prodOpen.valor=0;prodOpen.count=0;}
  persistOpens();
  payFullRender();
}
/* item 9: o Financeiro precisa dos itens dinâmicos AINDA em aberto (não pagos) pra deduzi-los
   do Caixa Real. Persistimos aqui (Gastos já calcula tudo) e o Financeiro só lê e exibe. */
var _opensSig='';
function persistOpens(force){
  var fo=pOpenOrders(freteBatches);
  var fFrom=null,fTo=null,fVal=0;
  if(fo.length){var fds=fo.map(pOrderDate).filter(Boolean).sort(function(a,b){return a-b;});fFrom=pIso(fds[0]);fTo=pIso(fds[fds.length-1]);fVal=pRound2(fo.reduce(function(s,o){return s+pFrete(o);},0));}
  var po=(prodOpen&&prodOpen.count&&prodOpen.valor!=null)?{valor:pRound2(prodOpen.valor),from:prodOpen.from,to:prodOpen.to,count:prodOpen.count}:null;
  if(po&&_openOvr.prod)po.ovr=_openOvr.prod;
  /* frete em aberto que cai na FATURA ATUAL (só os pedidos da janela). Vai DENTRO do frete_open
     (campo .fat) pra não depender de uma chave nova no config_save — o Financeiro lê daqui pra
     não contar o frete do mês passado na fatura (mantém os dois KPIs idênticos). */
  var win=faturaWindow(new Date());
  var ovr=payOvrGet('frete','open',null);
  var fatOpen=0;
  if(ovr){var od=toLocalDate(ovr);if(od&&od>=win.start&&od<=win.end)fatOpen=fo.reduce(function(s,o){return s+pFrete(o);},0);}
  else fo.forEach(function(o){var d=pOrderDate(o);if(d&&d>=win.start&&d<=win.end)fatOpen+=pFrete(o);});
  var fr=fo.length?{valor:fVal,from:fFrom,to:fTo,count:fo.length,fat:pRound2(fatOpen)}:null;
  if(fr&&_openOvr.frete)fr.ovr=_openOvr.frete;
  var payload={prod_open:JSON.stringify(po),frete_open:JSON.stringify(fr)};
  var sig=payload.prod_open+'|'+payload.frete_open;
  if(sig===_opensSig&&!force)return; _opensSig=sig;
  persistCfg(payload);
}
function pByToDesc(a,b){return String(b.to||'').localeCompare(String(a.to||''));}
/* os itens de Produtos são custo de INSUMOS — entram no cálculo por categoria junto com os insumos */
function insumosCatId(){var c=cats.find(function(x){return stripAcc(x.nome)==='insumos';});return c?String(c.id):null;}
function freteCatId(){var c=cats.find(function(x){return stripAcc(x.nome)==='frete';});return c?String(c.id):null;}
/* item 5: se já existe uma categoria "Produto" real, o custo dinâmico entra NELA (não cria uma 2ª) */
function produtoCatId(){var c=cats.find(function(x){return stripAcc(x.nome)==='produto';});return c?String(c.id):PRODUTOS_ID;}
function prodPayableEntries(){var id=produtoCatId();var out=[];prodBatches.forEach(function(b){out.push({cid:id,v:parseVal(b.valor),data:b.to});});if(prodOpen&&prodOpen.count&&prodOpen.valor!=null)out.push({cid:id,v:prodOpen.valor,data:prodOpen.to});return out;}
/* item 5/8: frete dinâmico (crédito) — entra em Gastos por categoria e na Fatura */
function fretePayableEntries(){var id=freteCatIdOr();var out=[];freteBatches.forEach(function(b){out.push({cid:id,v:parseVal(b.valor),data:b.to,credito:true});});var fo=pOpenOrders(freteBatches);if(fo.length){var fv=fo.reduce(function(s,o){return s+pFrete(o);},0);var fds=fo.map(pOrderDate).filter(Boolean).sort(function(a,b){return a-b;});out.push({cid:id,v:pRound2(fv),data:pIso(fds[fds.length-1]),credito:true});}return out;}
function payFullRender(){renderList();try{renderKpis();renderByCat();}catch(e){}}
/* linha pagável no MESMO formato das linhas normais (Data/Valor/Descrição/Prazo/Categoria/Tipo).
   Produtos = categoria Insumos. Data = hoje. Tipo = Pontual. Fundo #391313 enquanto não pago;
   depois de pago fica igual às outras. */
function payRow(kind,state,from,to,valor,count,paid,idx){
  var nm=kind==='prod'?'Produtos':'Frete';
  var catNm=kind==='prod'?'Produto':'Frete';
  var valTxt=(valor==null)?'…':BRL(valor);
  var range=pRangeLbl(from,to);
  /* na Fatura, o frete dinâmico <= corte (14 ago) já é pago → esmaecido e sem "a pagar" */
  var fatPago=(viewMode==='fatura'&&kind==='frete'&&beforeFaturaCutoff(to));
  var apagar=(paid||fatPago)?'':'<span class="mcg-pay-apagar">a pagar</span>';
  return '<div class="mcg-row mcg-pay-row'+(paid?'':' mcg-pay-open')+(fatPago?' is-paid-credit':'')+'" data-kind="'+kind+'" data-state="'+state+'"'+(idx!=null?' data-idx="'+idx+'"':'')+'>'
    +'<span class="mcg-row-catcell"><span class="mcg-row-cat-tag '+catTagClass(catNm)+'">'+catIcon(catNm)+'<span class="mcg-cat-txt">'+escH(catNm)+'</span></span></span>'
    +'<span class="mcg-row-val">'+valTxt+'</span>'
    +'<span class="mcg-row-desc">'+escH(nm)+(range?'<span class="mcg-row-notas">'+escH(range)+'</span>':'')+'</span>'
    +'<span class="mcg-row-prazo">'+apagar+'</span>'
    +'<span class="mcg-row-data">'+fmtDayMon(to)+'</span>'
    +'<span class="mcg-row-metodo '+(kind==='frete'?'is-credito':'is-pix')+'">'+(kind==='frete'?'Crédito':'Pix')+'</span>'
    +'<span class="mcg-row-tipo">Pontual</span>'
    +'<span class="mcg-row-del-sp"></span>'
    +'</div>';
}
/* item 5: linha de pedido (Venda) no mesmo formato — Categoria Venda · valor + · Pontual */
function orderRowHtml(o){
  var dt=pOrderDate(o);
  var v=parseVal(o.faturamento||o.total||o.valor||0);
  return '<div class="mcg-row mcg-order-row">'
    +'<span class="mcg-row-catcell"><span class="mcg-row-cat-tag mcg-cat-venda">'+catIcon('venda')+'<span class="mcg-cat-txt">Venda</span></span></span>'
    +'<span class="mcg-row-val"><span class="mcg-val-pos">+'+BRL(v)+'</span></span>'
    +'<span class="mcg-row-desc">Pedido #'+escH(o.order_number||o.id)+'</span>'
    +'<span class="mcg-row-prazo"></span>'
    +'<span class="mcg-row-tipo">Pontual</span>'
    +'<span class="mcg-row-data">'+fmtDayMon(pIso(dt))+'</span>'
    +'<span class="mcg-row-del-sp"></span>'
    +'</div>';
}
function renderPayableItems(){
  if(!_payReady)return [];
  var faturaMode=viewMode==='fatura';   /* item 8: na Fatura mostra os pagáveis de CRÉDITO (frete), não os de pix (produto) */
  var out=[], today=new Date();
  /* item 9: os pagáveis também respeitam os filtros — Produtos = categoria Insumos, Frete = categoria Frete,
     ambos do tipo Pontual. Se um filtro de categoria/tipo não bater, o item some. */
  var catEl=document.getElementById('mcg-filter-cat'), tipoEl=document.getElementById('mcg-filter-tipo');
  var catF=catEl?catEl.value:'', tipoF=tipoEl?tipoEl.value:'';
  function catOk(kind){if(!catF)return true;var id=kind==='prod'?produtoCatId():freteCatId();return id!=null&&String(catF)===String(id);}
  function tipoOk(){return !tipoF||tipoF==='pontual';}
  function add(kind,state,from,to,valor,count,paid,idx){
    /* item 1: Produtos só aparece quando o custo já é conhecido E maior que 0 —
       nunca mostra "…" nem 0, nem por um instante. Frete aparece independentemente. */
    if(kind==='prod'&&(valor==null||valor<=0))return;
    if(!catOk(kind)||!tipoOk())return;
    /* a data do item é a do ÚLTIMO pedido incluído (o "to"), não hoje */
    out.push({date:pDate(to)||today,html:payRow(kind,state,from,to,valor,count,paid,idx)});
  }
  /* Produtos e Frete são independentes: o frete aparece mesmo que o custo de produto seja 0 (item 3). */
  if(!faturaMode){   /* produto = pix, só na aba Gastos */
    var oo=pOpenOrders(prodBatches);
    if(oo.length)add('prod','open',prodOpen.from,payOvrGet('prod','open',null)||prodOpen.to,prodOpen.valor,oo.length,false);
    prodBatches.slice().sort(pByToDesc).forEach(function(b,i){add('prod','paid',b.from,payOvrGet('prod','paid',b)||b.to,b.pending?null:b.valor,b.count,true,i);});
  }
  /* frete = crédito → aparece nas DUAS abas (Gastos e Fatura) */
  var fo=pOpenOrders(freteBatches);
  if(!faturaMode){
    /* aba Gastos: item aberto inteiro + todos os lotes pagos */
    if(fo.length){var fv=fo.reduce(function(s,o){return s+pFrete(o);},0);var fds=fo.map(pOrderDate).filter(Boolean).sort(function(a,b){return a-b;});add('frete','open',pIso(fds[0]),payOvrGet('frete','open',null)||pIso(fds[fds.length-1]),pRound2(fv),fo.length,false);}
    freteBatches.slice().sort(pByToDesc).forEach(function(b,i){add('frete','paid',b.from,payOvrGet('frete','paid',b)||b.to,b.valor,b.count,true,i);});
  }else{
    /* aba Fatura: só o frete que cai na janela ATIVA (item 2 — sem vazar do mês passado).
       Item aberto: com override manual (item 3) o lote inteiro usa a data escolhida; sem override,
       cada pedido conta na fatura da sua própria data → aqui somamos só os da janela. */
    var win=activeFaturaWin();
    var ovr=payOvrGet('frete','open',null);
    if(fo.length){
      var wo, ofrom, oto, ofv;
      if(ovr){var od=toLocalDate(ovr); if(od>=win.start&&od<=win.end){wo=fo;ofrom=ovr;oto=ovr;}}
      else{wo=fo.filter(function(o){var d=pOrderDate(o);return d&&d>=win.start&&d<=win.end;});if(wo.length){var wds=wo.map(pOrderDate).sort(function(a,b){return a-b;});ofrom=pIso(wds[0]);oto=pIso(wds[wds.length-1]);}}
      if(wo&&wo.length){ofv=wo.reduce(function(s,o){return s+pFrete(o);},0);if(ofv)add('frete','open',ofrom,oto,pRound2(ofv),wo.length,false);}
    }
    freteBatches.slice().sort(pByToDesc).forEach(function(b,i){var d=payOvrGet('frete','paid',b)||b.to;var dt=toLocalDate(d)||(d?new Date(d):null);if(dt&&dt>=win.start&&dt<=win.end)add('frete','paid',b.from,d,b.valor,b.count,true,i);});
  }
  return out;
}
function bindPayable(el){
  el.querySelectorAll('.mcg-pay-row').forEach(function(row){
    row.addEventListener('click',function(){openPayModal(row.getAttribute('data-kind'),row.getAttribute('data-state'),row.getAttribute('data-idx'));});
  });
}
function payOrdersInRange(from,to){var a=pSOD(pDate(from)),b=pSOD(pDate(to));return finOrders.filter(pOrderPaid).filter(function(o){var d=pOrderDate(o);if(!d)return false;var ds=pSOD(d);return ds>=a&&ds<=b;}).sort(function(x,y){return pOrderDate(y)-pOrderDate(x);});}
function openPayModal(kind,state,idx){
  var nm=kind==='prod'?'Produtos':'Frete';
  var from,to,valor,count,isOpen=state==='open',batch=null;
  if(isOpen){
    var oo=pOpenOrders(kind==='prod'?prodBatches:freteBatches);
    var ds=oo.map(pOrderDate).filter(Boolean).sort(function(a,b){return a-b;});
    from=ds.length?pIso(ds[0]):pIso(new Date());to=pIso(new Date());count=oo.length;
    valor=kind==='prod'?prodOpen.valor:oo.reduce(function(s,o){return s+pFrete(o);},0);
  }else{
    batch=(kind==='prod'?prodBatches:freteBatches).slice().sort(pByToDesc)[+idx];
    if(!batch)return;from=batch.from;to=batch.to;valor=batch.valor;count=batch.count;
  }
  /* item 15: no item ABERTO usa exatamente os pedidos abertos (assim o frete aparece mesmo
     que o custo seja 0); nos lotes pagos usa o intervalo de datas. */
  var ords=isOpen
    ? pOpenOrders(kind==='prod'?prodBatches:freteBatches).slice().sort(function(a,b){return pOrderDate(b)-pOrderDate(a);})
    : payOrdersInRange(from,to);
  var oids=[];
  /* lista em formato tabela — ID · Cliente · Data · Custo · Itens */
  var rowsHtml=ords.slice(0,200).map(function(o){
    var d=pOrderDate(o);
    /* o custo de PRODUTO vem do custo da página de Produtos (soma dos itens × custo_unitario).
       Carrega junto com os tooltips; enquanto isso mostra "…" (usa o cache se já conhecido). */
    var lbl=kind==='frete'?BRL(pFrete(o)):(_prodOrderCost[o.id]!=null?BRL(_prodOrderCost[o.id]):'…');
    var qt=parseVal(o.itens_qtd||o.itens||o.qtd_itens||o.items_count||0);
    var cli=o.customer_name||o.cliente||o.customer||'-';
    var hov=kind==='prod'?(' data-oid="'+escH(o.id)+'"'):'';
    if(kind==='prod')oids.push(o.id);
    /* item 8: pedido sem bundle/camiseta/moletom (custo 0) fica riscado */
    var zero=kind==='prod'&&_prodOrderCost[o.id]!=null&&!(_prodOrderCost[o.id]>0);
    return '<div class="mcg-paydet-row'+(zero?' mcg-paydet-zero':'')+'"'+hov+'><span class="c-id">#'+escH(o.order_number||o.id)+'</span><span class="c-cli" title="'+escH(cli)+'">'+escH(cli)+'</span><span class="c-dt">'+(d?pDayLbl(d):'-')+'</span><span class="c-ct">'+lbl+'</span><span class="c-it">'+(qt||'-')+'</span></div>';
  }).join('');
  var ov=el2('mcg-pay-overlay'), body=el2('mcg-pay-body');
  el2('mcg-pay-title').textContent=nm+' · '+pRangeLbl(from,to);
  /* item 3: data manual do pagamento dinâmico (override). Padrão = data do último pedido (aberto)
     ou b.to (lote pago). Alterar reatribui o pagamento à fatura daquela data. */
  var curOvr=isOpen?payOvrGet(kind,'open',null):payOvrGet(kind,'paid',batch);
  var curDate=String(curOvr||to||pIso(new Date())).slice(0,10);
  body.innerHTML='<div class="mcg-paydet-top">'
      +'<div><span class="mcg-paydet-lbl">'+(isOpen?'A pagar':'Pago')+'</span><span class="mcg-paydet-val'+(kind==='prod'?' mcg-paytotal':'')+'"'+(kind==='prod'?' id="mcg-paytotal"':'')+'>'+(valor==null?'…':BRL(valor))+'</span></div>'
      +'<div><span class="mcg-paydet-lbl">Pedidos</span><span class="mcg-paydet-val">'+count+'</span></div>'
      +(isFaturaHist()
        ?'<div class="mcg-paydet-datecol"><span class="mcg-paydet-lbl">Data do pagamento</span><span class="mcg-paydet-val" style="font-size:14px">'+fmtDayMon(curDate)+'</span></div>'
        :'<div class="mcg-paydet-datecol"><span class="mcg-paydet-lbl">Data do pagamento</span>'
          +'<span class="mcg-paydet-daterow"><input type="date" id="mcg-pay-date" class="mcg-input mcg-pay-dateinput" value="'+escH(curDate)+'">'
          +(curOvr?'<button type="button" id="mcg-pay-date-reset" class="mcg-paydet-datereset" title="Voltar ao padrão">padrão</button>':'')+'</span>'
        +'</div>')
    +'</div>'
    +'<div class="mcg-paydet-box">'
      +'<div class="mcg-paydet-head"><span class="c-id">ID</span><span class="c-cli">Cliente</span><span class="c-dt">Data</span><span class="c-ct">Custo</span><span class="c-it">Itens</span></div>'
      +'<div class="mcg-paydet-list">'+(rowsHtml||'<p class="mc-empty" style="padding:12px">Sem pedidos.</p>')+'</div>'
    +'</div>';
  var foot=el2('mcg-pay-foot');
  foot.innerHTML=(isOpen&&!isFaturaHist())
    ? '<button class="mcg-btn-ghost" id="mcg-pay-cancel">Fechar</button><span style="flex:1"></span><button class="mcg-btn-acc" id="mcg-pay-pago">Marcar como pago</button>'
    : '<span style="flex:1"></span><button class="mcg-btn-ghost" id="mcg-pay-cancel">Fechar</button>';
  ov.style.display='flex';
  var cancel=el2('mcg-pay-cancel'); if(cancel)cancel.addEventListener('click',closePayModal);
  var pago=el2('mcg-pay-pago');
  if(pago)pago.addEventListener('click',function(){markPago(kind);});
  /* item 3: aplica/reseta a data manual do pagamento dinâmico */
  var dinp=el2('mcg-pay-date');
  if(dinp)dinp.addEventListener('change',function(){var v=this.value||null;setPayDateOvr(kind,isOpen?'open':'paid',batch,v);closePayModal();payFullRender();});
  var drst=el2('mcg-pay-date-reset');
  if(drst)drst.addEventListener('click',function(){setPayDateOvr(kind,isOpen?'open':'paid',batch,null);closePayModal();payFullRender();});
  if(kind==='prod'){
    bindPayTips();prefetchPayTips(oids);bindPayTotalTip(ords);   /* item 13: pré-carrega os tooltips; item 7: tooltip no total */
    /* item 8: o total "Pago"/"A pagar" é EXATAMENTE a soma do custo por pedido da lista exibida
       (recalcula sobre os mesmos pedidos e regrava, evitando divergência com a coluna Custo). */
    computeOrdersProdCost(ords,function(v){
      var tt=document.getElementById('mcg-paytotal'); if(tt)tt.textContent=BRL(v);
      if(isOpen){prodOpen.valor=v;}
      else if(batch&&pRound2(batch.valor)!==pRound2(v)){batch.valor=pRound2(v);batch.pending=false;pPersist();}
      try{renderKpis();renderByCat();renderList();}catch(e){}
    });
  }
}
/* item 7: hover no total "Pago"/"A pagar" mostra o custo considerado de cada pedido */
function bindPayTotalTip(ords){
  var el=document.getElementById('mcg-paytotal'); if(!el)return;
  function build(){
    var rows=ords.map(function(o){var c=_prodOrderCost[o.id];var v=c==null?'…':BRL(c);var off=c!=null&&!(c>0);return '<div class="mcg-paytip-row'+(off?' mcg-paytip-off':'')+'"><span>#'+escH(o.order_number||o.id)+'</span><span>'+v+'</span></div>';}).join('');
    return '<div class="mcg-kt-h">Custo considerado por pedido</div>'+(rows||'<div class="mcg-paytip-empty">Sem pedidos</div>');
  }
  el.addEventListener('mousemove',function(e){var t=payTip();t.style.left=Math.min(e.clientX+14,window.innerWidth-260)+'px';t.style.top=(e.clientY+16)+'px';});
  el.addEventListener('mouseenter',function(){var t=payTip();t.innerHTML=build();t.classList.add('show');});
  el.addEventListener('mouseleave',function(){payTip().classList.remove('show');});
}
/* item 13: busca os itens de todos os pedidos do detalhe de uma vez e guarda no cache,
   pra que o hover apareça instantâneo. */
var _prodOrderCost={};   /* custo de produto por pedido (base: custo da página de Produtos) */
function _fillCostCell(oid,val){
  Array.prototype.forEach.call(document.querySelectorAll('.mcg-paydet-row[data-oid]'),function(r){
    if(r.getAttribute('data-oid')===String(oid)){var c=r.querySelector('.c-ct');if(c)c.textContent=BRL(val);r.classList.toggle('mcg-paydet-zero',!(val>0));}   /* item 8: custo 0 = riscado */
  });
}
function prefetchPayTips(oids){
  if(!oids||!oids.length)return;
  ensureProdCost(function(map){
    oids.forEach(function(oid){
      if(_prodOrderCost[oid]!=null){_fillCostCell(oid,_prodOrderCost[oid]);}
      if(_payTipCache[oid]!=null&&_prodOrderCost[oid]!=null)return;
      pedCall('order',{id:oid},function(e,d){
        var items=(d&&(d.rows||d.data||d.items||d.line_items||d.itens||d.produtos||(d.order&&(d.order.items||d.order.line_items))))||[];
        if(!Array.isArray(items))items=[];
        _payTipCache[oid]=payTipHtml(items,map);
        /* item 6: custo do pedido = soma APENAS de bundle/camiseta/moletom, pelo custo da página de Produtos */
        _prodOrderCost[oid]=orderProdCost(items,map);
        _fillCostCell(oid,_prodOrderCost[oid]);
      });
    });
  });
}
/* item 3: total = SOMA EXATA dos custos por pedido (mesmos valores da coluna Custo).
   Busca os itens de cada pedido (usa cache) e soma orderProdCost. */
function computeOrdersProdCost(orders,cb){
  ensureProdCost(function(map){
    var list=(orders||[]).slice(), pending=list.length, total=0;
    if(!pending){cb(0);return;}
    list.forEach(function(o){
      if(_prodOrderCost[o.id]!=null){total+=_prodOrderCost[o.id];if(--pending===0)cb(pRound2(total));return;}
      pedCall('order',{id:o.id},function(e,d){
        var items=(d&&(d.rows||d.data||d.items||d.line_items||d.itens||d.produtos||(d.order&&(d.order.items||d.order.line_items))))||[];
        if(!Array.isArray(items))items=[];
        _prodOrderCost[o.id]=orderProdCost(items,map);
        _payTipCache[o.id]=payTipHtml(items,map);
        total+=_prodOrderCost[o.id];
        if(--pending===0)cb(pRound2(total));
      });
    });
  });
}
/* item 1: mapa de custo por produto (products_clean) — os itens do pedido não trazem o custo,
   então buscamos custo_unitario da lista de produtos e casamos por SKU/variação. Carrega 1x. */
var _prodCostMap=null,_prodCostLoading=false,_prodCostWaiters=[];
function ensureProdCost(cb){
  if(_prodCostMap){cb(_prodCostMap);return;}
  _prodCostWaiters.push(cb);
  if(_prodCostLoading)return; _prodCostLoading=true;
  pedCall('products',{},function(e,d){
    var rows=(d&&(d.rows||d.data))||[]; var m={bySku:{},byVar:{},byPid:{},byTitleVar:{},byTitle:{},typeBySku:{},typeByVar:{},typeByPid:{},typeByTitle:{}};
    if(Array.isArray(rows))rows.forEach(function(r){
      var sk=String(r.sku||'').trim(),vi=String(r.variant_id||'').trim(),pi=String(r.product_id||'').trim();
      var pt=stripAcc(r.product_title||r.title||''), vt=stripAcc(r.variant_title||'');
      var pty=stripAcc(r.product_type||'');
      /* mapa de TIPO de produto (pra saber se é bundle/camiseta/moletom) */
      if(sk&&m.typeBySku[sk]==null)m.typeBySku[sk]=pty;
      if(vi&&m.typeByVar[vi]==null)m.typeByVar[vi]=pty;
      if(pi&&m.typeByPid[pi]==null)m.typeByPid[pi]=pty;
      if(pt&&m.typeByTitle[pt]==null)m.typeByTitle[pt]=pty;
      var cu=parseVal(r.custo_unitario); if(!cu)return;
      if(sk&&m.bySku[sk]==null)m.bySku[sk]=cu;
      if(vi&&m.byVar[vi]==null)m.byVar[vi]=cu;
      if(pi&&m.byPid[pi]==null)m.byPid[pi]=cu;
      /* item 12: também casa por título+variação e por título (quando o SKU não bate) */
      if(pt){if(m.byTitleVar[pt+'|'+vt]==null)m.byTitleVar[pt+'|'+vt]=cu;if(m.byTitle[pt]==null)m.byTitle[pt]=cu;}
    });
    _prodCostMap=m;_prodCostLoading=false;
    var ws=_prodCostWaiters;_prodCostWaiters=[];ws.forEach(function(f){f(m);});
  });
}
function itemCost(it,map){
  var direct=parseVal(it.custo_unitario||it.custo||it.custo_produto||it.preco_custo||0); if(direct)return direct;
  var sk=String(it.sku||'').trim(),vi=String(it.variant_id||'').trim(),pi=String(it.product_id||'').trim();
  if(sk&&map.bySku[sk]!=null)return map.bySku[sk];
  if(vi&&map.byVar[vi]!=null)return map.byVar[vi];
  if(pi&&map.byPid[pi]!=null)return map.byPid[pi];
  /* item 12: fallback por título (+ variação) — pega custo quando o SKU do pedido não bate */
  var pt=stripAcc(it.title||it.product_title||''), vt=stripAcc(it.variant_title||'');
  if(pt&&map.byTitleVar&&map.byTitleVar[pt+'|'+vt]!=null)return map.byTitleVar[pt+'|'+vt];
  if(pt&&map.byTitle&&map.byTitle[pt]!=null)return map.byTitle[pt];
  return 0;
}
/* tipo de produto do item (bundle/camiseta/moletom?) via mapa da página de Produtos */
function itemType(it,map){
  if(!map)return'';
  var sk=String(it.sku||'').trim(),vi=String(it.variant_id||'').trim(),pi=String(it.product_id||'').trim();
  if(sk&&map.typeBySku&&map.typeBySku[sk]!=null)return map.typeBySku[sk];
  if(vi&&map.typeByVar&&map.typeByVar[vi]!=null)return map.typeByVar[vi];
  if(pi&&map.typeByPid&&map.typeByPid[pi]!=null)return map.typeByPid[pi];
  var pt=stripAcc(it.title||it.product_title||'');
  if(pt&&map.typeByTitle&&map.typeByTitle[pt]!=null)return map.typeByTitle[pt];
  return stripAcc(it.product_type||'');
}
function itemIsProd(it,map){return pMatchType(itemType(it,map)||'');}
/* soma o custo APENAS de bundle/camiseta/moletom do pedido (item 6) */
function orderProdCost(items,map){var s=0;items.forEach(function(it){if(!itemIsProd(it,map))return;var q=parseVal(it.quantity||it.qtd||it.qty||it.quantidade||1)||1;s+=itemCost(it,map)*q;});return pRound2(s);}
function payTipHtml(items,map){
  return items.map(function(it){
    var qty=parseVal(it.quantity||it.qtd||it.qty||it.quantidade||1)||1;
    var c=itemCost(it,map)*qty;
    var nm=it.title||it.product_title||it.nome||it.name||it.produto||'Produto';
    var vt=it.variant_title&&String(it.variant_title).toLowerCase()!=='default title'?(' '+it.variant_title):'';
    /* item 6: item que não é bundle/camiseta/moletom fica riscado e apagado (e não soma) */
    var off=!itemIsProd(it,map);
    return '<div class="mcg-paytip-row'+(off?' mcg-paytip-off':'')+'"><span>'+escH(qty+'× '+nm+vt)+'</span><span>'+BRL(c)+'</span></div>';
  }).join('')||'<div class="mcg-paytip-empty">Sem itens</div>';
}
/* tooltip por pedido (itens + custo de cada produto) no hover */
var _payTipCache={};
function payTip(){var t=document.getElementById('mcg-paytip');if(!t){t=document.createElement('div');t.id='mcg-paytip';document.body.appendChild(t);}return t;}
function bindPayTips(){
  Array.prototype.forEach.call(document.querySelectorAll('.mcg-paydet-row[data-oid]'),function(row){
    var oid=row.getAttribute('data-oid');
    row.addEventListener('mousemove',function(e){var t=payTip();t.style.left=Math.min(e.clientX+14,window.innerWidth-260)+'px';t.style.top=(e.clientY+14)+'px';});
    row.addEventListener('mouseenter',function(){
      var t=payTip();t.classList.add('show');
      if(_payTipCache[oid]!=null){t.innerHTML=_payTipCache[oid];return;}   /* item 13: instantâneo se pré-carregado */
      t.innerHTML='<div class="mcg-paytip-empty">Carregando…</div>';
      ensureProdCost(function(map){
        pedCall('order',{id:oid},function(e,d){
          var items=(d&&(d.rows||d.data||d.items||d.line_items||d.itens||d.produtos||(d.order&&(d.order.items||d.order.line_items))))||[];
          if(!Array.isArray(items))items=[];
          _payTipCache[oid]=payTipHtml(items,map);
          payTip().innerHTML=_payTipCache[oid];
        });
      });
    });
    row.addEventListener('mouseleave',function(){payTip().classList.remove('show');});
  });
}
function closePayModal(){var ov=el2('mcg-pay-overlay');if(ov)ov.style.display='none';var t=document.getElementById('mcg-paytip');if(t)t.classList.remove('show');}
function el2(id){return document.getElementById(id);}
function markPago(kind){
  if(kind==='prod'){
    var oo=pOpenOrders(prodBatches); if(!oo.length){closePayModal();return;}
    var ds=oo.map(pOrderDate).filter(Boolean).sort(function(a,b){return a-b;});
    var nowISO=new Date().toISOString();
    prodBatches.push({from:pIso(ds[0]),to:pIso(new Date()),valor:pRound2(prodOpen.valor||0),count:oo.length,paidAt:nowISO,cutoff:nowISO});
  }else{
    var fo=pOpenOrders(freteBatches); if(!fo.length){closePayModal();return;}
    var fds=fo.map(pOrderDate).filter(Boolean).sort(function(a,b){return a-b;});
    var fv=fo.reduce(function(s,o){return s+pFrete(o);},0);
    var nowISO2=new Date().toISOString();
    freteBatches.push({from:pIso(fds[0]),to:pIso(new Date()),valor:pRound2(fv),count:fo.length,paidAt:nowISO2,cutoff:nowISO2});
  }
  pPersist();
  closePayModal();
  refreshPayables();
}

/* ───── init ───── */
function init(){
  var _root=document.getElementById('mc-root');
  MC_PAGE=(_root&&_root.dataset&&_root.dataset.page)||'gastos';
  if(MC_PAGE==='fatura'){viewMode='fatura';if(_root)_root.classList.add('is-fatura','is-fatura-page');}
  setupRange();
  var _new=document.getElementById('mcg-btn-new');
  if(_new)_new.addEventListener('click',function(){openModal(null);});
  /* item 5: dropdown de faturas passadas (só na página Fatura) */
  var fatSel=document.getElementById('mcg-filter-fatura');
  if(fatSel)fatSel.addEventListener('change',function(){
    var v=this.value;
    faturaViewRef=v?new Date(+v.slice(0,4),+v.slice(5,7)-1,3):null;
    applyFilters();
  });
  var notasEl=document.getElementById('mcg-f-notas');
  if(notasEl)notasEl.addEventListener('input',function(){autoGrow(notasEl);});
  var futBtn=document.getElementById('mcg-toggle-fut');
  if(futBtn)futBtn.addEventListener('change',function(){
    showFuturos=futBtn.checked;
    if(showFuturos){horizMeses=0;persistCfg({gastos_horizonte_meses:'0'});}   /* item 9: padrão = mês atual */
    syncFutUI(true);   /* anima o dropdown de meses crescendo/encolhendo */
    _animByCat=true;   /* anima a entrada das novas categorias + crescimento suave */
    _animFutureIn=showFuturos;   /* anima os gastos futuros entrando na lista */
    applyFilters();
    persistCfg({incluir_futuros:showFuturos?'1':'0'});
  });
  var futMeses=document.getElementById('mcg-fut-meses');
  if(futMeses)futMeses.addEventListener('change',function(){
    var v=Number(futMeses.value);           /* aceita 0 = "mês atual" */
    if(isNaN(v))v=1;
    if(v===horizMeses)return;
    horizMeses=v;
    _animByCat=true;_animFutureIn=true;
    applyFilters();
    persistCfg({gastos_horizonte_meses:String(v)});
  });
  document.getElementById('mcg-modal-close').addEventListener('click',closeModalForce);
  document.getElementById('mcg-modal-cancel').addEventListener('click',closeModalForce);
  document.getElementById('mcg-modal-overlay').addEventListener('click',function(e){if(e.target===this)closeModalForce();});
  document.getElementById('mcg-modal-save').addEventListener('click',saveGasto);
  document.getElementById('mcg-modal-del').addEventListener('click',function(){if(editId)confirmDel(editId);});
  document.getElementById('mcg-f-tipo').addEventListener('change',function(){updateTipoBlocks(this.value);});
  document.getElementById('mcg-f-cat').addEventListener('change',onCatChange);
  /* itens 3 e 4: clicar FORA da janela de detalhe fecha; mas arrastar (seleção de texto)
     que começa dentro e solta fora NÃO fecha — só fecha quando o mousedown foi no overlay. */
  var payOv=document.getElementById('mcg-pay-overlay');
  if(payOv){
    var _payDownOnOv=false;
    payOv.addEventListener('mousedown',function(e){_payDownOnOv=(e.target===payOv);});
    payOv.addEventListener('click',function(e){var close=(e.target===payOv&&_payDownOnOv);_payDownOnOv=false;if(close)closePayModal();});
  }
  document.getElementById('mcg-cat-close').addEventListener('click',closeCatModalForce);
  document.getElementById('mcg-cat-overlay').addEventListener('click',function(e){if(e.target===this)closeCatModalForce();});
  document.getElementById('mcg-cat-add').addEventListener('click',addCat);
  document.getElementById('mcg-search').addEventListener('input',applyFilters);
  document.getElementById('mcg-filter-cat').addEventListener('change',applyFilters);
  document.getElementById('mcg-filter-tipo').addEventListener('change',applyFilters);
  document.getElementById('mcg-filter-clear').addEventListener('click',function(){
    document.getElementById('mcg-search').value='';
    document.getElementById('mcg-filter-cat').value='';
    document.getElementById('mcg-filter-tipo').value='';
    refreshCSById('mcg-filter-cat');refreshCSById('mcg-filter-tipo');
    applyFilters();
  });
  ['mcg-f-data','mcg-f-inicio','mcg-f-fim','mcg-f-parc-data'].forEach(buildDateField);
  bindKpiTips();
  bindViews();
  buildAllCS();
  document.addEventListener('click',function(){closeAllCS();closeAllDCal();});
  window.addEventListener('beforeunload',function(e){
    if(pendingSaves>0){e.preventDefault();e.returnValue='';return '';}
  });
  document.getElementById('mcg-updated').textContent='Atualizado '+new Date().toLocaleTimeString('pt-BR',{hour:'2-digit',minute:'2-digit'});
  bootCfg();
  loadCats(loadGastos);
  loadPayables();
}

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();